function OnBoardingBannerImage() {
  return (
    <svg
      width="828"
      height="355"
      viewBox="0 0 828 353"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.4194 354.379V354.373C31.888 354.326 28.7393 352.729 27.238 349.834C24.8662 345.263 27.495 339.199 33.106 336.293C33.8596 335.902 34.6278 335.595 35.3989 335.355C36.0766 329.099 39.9935 323.906 45.657 322.632C48.8262 321.919 52.0245 322.553 54.8052 324.189C58.8302 315.374 67.5724 310.142 76.1013 312.12C83.4152 313.817 88.5297 320.345 89.6659 328.278C90.7408 328.541 91.8273 328.874 92.9081 329.289C102.369 332.919 108.032 341.092 105.555 347.544C103.92 351.806 99.1441 354.251 93.3666 354.373V354.379H35.4194Z"
        fill="#209E20"
      />
      <path
        d="M70.3115 354.384C70.3115 354.384 73.3551 345.458 88.0062 342.738"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M64.542 354.385C64.542 354.385 75.0309 339.184 73.3572 328.441"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M58.4298 354.457C58.4298 354.457 56.3239 342.037 47.7949 334.309"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M36.5771 344.379C36.5771 344.379 42.3225 347.498 55.2065 344.712"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M71.9581 205.224C90.8756 194.152 99.1148 173.051 90.3608 158.095C81.6068 143.138 59.1746 139.989 40.2571 151.061C21.3396 162.134 13.1004 183.234 21.8544 198.191C30.6084 213.147 53.0405 216.296 71.9581 205.224Z"
        fill="#6ACA68"
      />
      <path
        d="M97.0089 176.057C115.445 168.018 122.941 144.417 113.751 123.342C104.562 102.268 82.1667 91.7012 63.7304 99.7405C45.2942 107.78 37.7983 131.381 46.9879 152.455C56.1775 173.529 78.5726 184.096 97.0089 176.057Z"
        fill="#6ACA68"
      />
      <path
        d="M121.962 203.969C123.899 191.132 109.278 178.282 89.306 175.269C69.3337 172.255 51.5728 180.219 49.636 193.057C47.6991 205.894 62.3196 218.744 82.2919 221.757C102.264 224.77 120.025 216.806 121.962 203.969Z"
        fill="#6ACA68"
      />
      <path
        d="M54.0282 178.798C73.2173 172.355 85.1731 156.41 80.7322 143.183C76.2912 129.957 57.1353 124.457 37.9461 130.9C18.757 137.343 6.80127 153.289 11.2422 166.515C15.6832 179.742 34.8391 185.241 54.0282 178.798Z"
        fill="#6ACA68"
      />
      <path
        d="M168.487 164.918C170.532 150.08 155.936 135.811 135.886 133.046C115.835 130.282 97.9227 140.069 95.877 154.907C93.8312 169.745 108.427 184.014 128.478 186.779C148.528 189.543 166.441 179.756 168.487 164.918Z"
        fill="#6ACA68"
      />
      <path
        d="M147.506 158.076C152.386 138.431 143.779 119.386 128.283 115.536C112.787 111.687 96.2692 124.492 91.3894 144.137C86.5096 163.782 95.1158 182.827 110.612 186.677C126.108 190.526 142.626 177.721 147.506 158.076Z"
        fill="#6ACA68"
      />
      <path
        d="M144.359 202.729C155.764 194.678 158.701 179.216 150.92 168.193C143.138 157.17 127.585 154.762 116.18 162.813C104.776 170.864 101.838 186.326 109.62 197.349C117.401 208.371 132.954 210.78 144.359 202.729Z"
        fill="#6ACA68"
      />
      <path
        d="M108.647 169.859C108.647 169.859 102.426 283.87 115.193 354.438H63C75.7672 283.87 69.5457 169.859 69.5457 169.859"
        fill="#6ACA68"
      />
      <path
        d="M397.249 199.234C416.926 187.717 425.495 165.77 416.39 150.214C407.285 134.657 383.953 131.382 364.276 142.898C344.6 154.414 336.031 176.361 345.136 191.918C354.241 207.475 377.573 210.75 397.249 199.234Z"
        fill="#6ACA68"
      />
      <path
        d="M423.332 168.937C442.509 160.575 450.307 136.026 440.749 114.106C431.19 92.1863 407.895 81.1956 388.718 89.5579C369.541 97.9202 361.744 122.469 371.302 144.389C380.861 166.309 404.155 177.3 423.332 168.937Z"
        fill="#6ACA68"
      />
      <path
        d="M449.293 197.958C451.308 184.606 436.101 171.24 415.328 168.106C394.555 164.972 376.082 173.256 374.068 186.608C372.053 199.961 387.26 213.326 408.033 216.46C428.806 219.594 447.279 211.311 449.293 197.958Z"
        fill="#6ACA68"
      />
      <path
        d="M378.614 171.751C398.574 165.049 411.01 148.464 406.391 134.707C401.772 120.95 381.846 115.23 361.887 121.932C341.927 128.634 329.491 145.219 334.11 158.976C338.729 172.733 358.654 178.453 378.614 171.751Z"
        fill="#6ACA68"
      />
      <path
        d="M497.65 157.326C499.778 141.894 484.596 127.052 463.74 124.177C442.884 121.301 424.252 131.481 422.124 146.913C419.996 162.345 435.179 177.186 456.035 180.062C476.891 182.937 495.523 172.758 497.65 157.326Z"
        fill="#6ACA68"
      />
      <path
        d="M475.87 150.208C480.946 129.774 471.993 109.963 455.874 105.959C439.755 101.955 422.573 115.274 417.497 135.708C412.421 156.142 421.374 175.953 437.493 179.957C453.612 183.961 470.794 170.642 475.87 150.208Z"
        fill="#6ACA68"
      />
      <path
        d="M472.574 196.678C484.436 188.304 487.491 172.221 479.397 160.755C471.303 149.29 455.125 146.784 443.263 155.158C431.401 163.532 428.347 179.615 436.44 191.08C444.534 202.546 460.712 205.052 472.574 196.678Z"
        fill="#6ACA68"
      />
      <path
        d="M435.426 162.465C435.426 162.465 428.956 281.052 442.235 354.451H387.947C401.226 281.052 394.756 162.465 394.756 162.465"
        fill="#6ACA68"
      />
      <path
        d="M738.394 226.428C754.617 216.932 761.683 198.837 754.176 186.01C746.669 173.184 727.431 170.483 711.207 179.979C694.984 189.474 687.918 207.57 695.425 220.396C702.932 233.223 722.17 235.923 738.394 226.428Z"
        fill="#6ACA68"
      />
      <path
        d="M759.916 201.497C775.727 194.603 782.157 174.363 774.276 156.29C766.395 138.218 747.189 129.156 731.377 136.051C715.566 142.946 709.137 163.186 717.017 181.258C724.898 199.331 744.104 208.392 759.916 201.497Z"
        fill="#6ACA68"
      />
      <path
        d="M781.342 225.413C783.003 214.403 770.465 203.383 753.336 200.799C736.208 198.215 720.976 205.045 719.315 216.054C717.654 227.063 730.193 238.083 747.321 240.668C764.449 243.252 779.681 236.422 781.342 225.413Z"
        fill="#6ACA68"
      />
      <path
        d="M723.037 203.781C739.494 198.256 749.747 184.582 745.939 173.239C742.13 161.897 725.702 157.181 709.246 162.706C692.79 168.232 682.537 181.906 686.345 193.248C690.153 204.591 706.581 209.307 723.037 203.781Z"
        fill="#6ACA68"
      />
      <path
        d="M821.157 191.9C822.911 179.175 810.393 166.937 793.196 164.566C776 162.196 760.637 170.589 758.883 183.315C757.128 196.04 769.647 208.277 786.843 210.648C804.04 213.019 819.402 204.626 821.157 191.9Z"
        fill="#6ACA68"
      />
      <path
        d="M803.258 186.06C807.443 169.213 800.062 152.879 786.771 149.578C773.481 146.277 759.315 157.258 755.13 174.105C750.945 190.952 758.327 207.286 771.617 210.587C784.907 213.888 799.073 202.907 803.258 186.06Z"
        fill="#6ACA68"
      />
      <path
        d="M800.518 224.345C810.297 217.441 812.816 204.181 806.142 194.728C799.469 185.275 786.131 183.208 776.351 190.112C766.572 197.016 764.053 210.276 770.727 219.729C777.4 229.182 790.738 231.249 800.518 224.345Z"
        fill="#6ACA68"
      />
      <path
        d="M769.881 196.148C769.881 196.148 764.547 293.925 775.495 354.445H730.735C741.683 293.925 736.349 196.148 736.349 196.148"
        fill="#6ACA68"
      />
      <path
        d="M187.245 114.328L218.428 151.119L217.821 264.692"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M218.429 155.291C220.739 155.291 222.611 153.419 222.611 151.108C222.611 148.798 220.739 146.926 218.429 146.926C216.119 146.926 214.246 148.798 214.246 151.108C214.246 153.419 216.119 155.291 218.429 155.291Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.429 151.773C218.793 151.773 219.089 151.478 219.089 151.113C219.089 150.749 218.793 150.453 218.429 150.453C218.064 150.453 217.769 150.749 217.769 151.113C217.769 151.478 218.064 151.773 218.429 151.773Z"
        fill="#0E4D0D"
      />
      <path
        d="M165.198 130.797L196.876 102.523L186.28 90.6515L154.602 118.925L165.198 130.797Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M160.444 129.709L162.551 127.828L156.689 121.26L154.581 123.141L160.444 129.709Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.464 119.264L194.812 100.211L186.28 90.6484L154.604 118.923L173.464 119.264Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.943 116.842C183.289 119.47 187.32 119.698 189.948 117.353C192.577 115.007 192.805 110.976 190.46 108.348L180.943 116.842Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.624 116.489L197.284 95.3745L189.175 86.2876C187.802 84.7483 185.442 84.614 183.903 85.9868L150.438 115.856L173.624 116.489Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M187.8 114.419C187.844 114.113 187.63 113.829 187.324 113.785C187.017 113.741 186.733 113.955 186.689 114.261C186.646 114.568 186.859 114.852 187.166 114.896C187.472 114.939 187.756 114.726 187.8 114.419Z"
        fill="#0E4D0D"
      />
      <path
        d="M173.575 95.1992L169.79 98.5776L168.504 97.1372C167.573 96.0934 167.664 94.4891 168.708 93.5575C169.751 92.6259 171.356 92.7169 172.287 93.7607L173.573 95.2012L173.575 95.1992Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M204.869 126.973H626.033C631.288 126.973 635.552 131.237 635.552 136.492V354.445H195.35V136.492C195.35 131.237 199.614 126.973 204.869 126.973Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M633.986 290.996H741.016C746.271 290.996 750.535 295.261 750.535 300.515V354.449H633.986V290.996Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M658.635 176.08L670.978 164.102H696.638L709.216 176.065C711.973 178.688 713.533 182.325 713.533 186.128V287.246C713.533 289.302 711.865 290.97 709.809 290.97H658.141C656.085 290.97 654.417 289.302 654.417 287.246V186.046C654.417 182.29 655.939 178.694 658.635 176.08Z"
        fill="#B0E4AB"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M675.806 141.328H691.809C694.473 141.328 696.637 143.492 696.637 146.156V164.105H670.978V146.156C670.978 143.492 673.142 141.328 675.806 141.328Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M670.978 152.48H696.97"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M685.547 152.48C685.547 154.873 683.608 156.809 681.218 156.809C678.829 156.809 676.89 154.87 676.89 152.48"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M694.871 169.719L700.099 176.41C702.006 178.852 703.043 181.861 703.043 184.96V287.252C703.043 289.308 701.376 290.976 699.319 290.976H690.235"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M159.395 290.952H110.137C105.91 290.952 102.537 287.429 102.718 283.205L104.359 245.237C104.876 233.247 104.876 221.236 104.359 209.246L103.206 182.57C102.756 172.192 111.051 163.531 121.438 163.531H148.091C158.48 163.531 166.773 172.192 166.323 182.57L165.169 209.246C164.652 221.236 164.652 233.247 165.169 245.237L166.811 283.205C166.992 287.429 163.618 290.952 159.392 290.952H159.395Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M126.958 141.312H142.573C145.173 141.312 147.285 143.424 147.285 146.024V163.537H122.244V146.024C122.244 143.424 124.356 141.312 126.956 141.312H126.958Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M141.434 163.537V146.024C141.434 143.421 139.325 141.312 136.723 141.312"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M159.395 290.952H110.137C105.91 290.952 102.537 287.429 102.718 283.205L104.359 245.237C104.876 233.247 104.876 221.236 104.359 209.246L103.206 182.57C102.756 172.192 111.051 163.531 121.438 163.531H148.091C158.48 163.531 166.773 172.192 166.323 182.57L165.169 209.246C164.652 221.236 164.652 233.247 165.169 245.237L166.811 283.205C166.992 287.429 163.618 290.952 159.392 290.952H159.395Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M141.435 163.531C151.824 163.531 160.116 172.192 159.667 182.57L158.513 209.246C157.996 221.236 157.996 233.247 158.513 245.237L160.154 283.205C160.336 287.429 156.962 290.952 152.735 290.952"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M122.247 152.18H147.615"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M135.847 152.18C135.847 154.303 134.124 156.026 132 156.026C129.877 156.026 128.153 154.303 128.153 152.18"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M55.5339 192.273L44.1221 223.43L79.1522 290.958"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1233 227.862C46.5737 227.862 48.5601 225.875 48.5601 223.425C48.5601 220.975 46.5737 218.988 44.1233 218.988C41.673 218.988 39.6865 220.975 39.6865 223.425C39.6865 225.875 41.673 227.862 44.1233 227.862Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1248 224.111C44.5104 224.111 44.8229 223.798 44.8229 223.413C44.8229 223.027 44.5104 222.715 44.1248 222.715C43.7393 222.715 43.4268 223.027 43.4268 223.413C43.4268 223.798 43.7393 224.111 44.1248 224.111Z"
        fill="#0E4D0D"
      />
      <path
        d="M89.5 183.952L47.1846 168.551L41.4124 184.41L83.7278 199.811L89.5 183.952Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M91.1756 188.102L88.3623 187.078L85.1695 195.85L87.9828 196.874L91.1756 188.102Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.0507 191.702L42.5342 181.324L47.1842 168.551L89.499 183.953L71.0507 191.702Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.7335 192.263C61.4571 195.774 57.5752 197.585 54.0643 196.306C50.5534 195.029 48.7425 191.148 50.0218 187.637L62.7335 192.263Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.8041 189.034L38.2002 177.531L42.6166 165.395C43.3643 163.339 45.6367 162.281 47.693 163.029L92.3971 179.298L69.8041 189.037V189.034Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.5343 192.854C55.8618 192.854 56.1273 192.588 56.1273 192.261C56.1273 191.933 55.8618 191.668 55.5343 191.668C55.2069 191.668 54.9414 191.933 54.9414 192.261C54.9414 192.588 55.2069 192.854 55.5343 192.854Z"
        fill="#0E4D0D"
      />
      <path
        d="M66.5439 169.887L61.4882 168.047L62.1885 166.123C62.6959 164.728 64.2421 164.007 65.6364 164.515C67.0307 165.022 67.7517 166.568 67.2442 167.963L66.5439 169.887Z"
        fill="#90CEFF"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M74.5148 250.469L45.7617 286.822L75.3297 354.396"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.7629 292.887C49.1167 292.887 51.8354 290.168 51.8354 286.815C51.8354 283.461 49.1167 280.742 45.7629 280.742C42.4092 280.742 39.6904 283.461 39.6904 286.815C39.6904 290.168 42.4092 292.887 45.7629 292.887Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.7637 287.779C46.2928 287.779 46.7218 287.35 46.7218 286.821C46.7218 286.292 46.2928 285.863 45.7637 285.863C45.2346 285.863 44.8057 286.292 44.8057 286.821C44.8057 287.35 45.2346 287.779 45.7637 287.779Z"
        fill="#0E4D0D"
      />
      <path
        d="M66.0605 354.424C66.0605 349.307 70.2111 345.156 75.3285 345.156C80.4459 345.156 84.5964 349.307 84.5964 354.424H66.0605Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.252 273.406H136.668C139.027 273.406 140.938 271.494 140.938 269.136V231.775C140.938 229.417 139.027 227.505 136.668 227.505H85.252C82.8935 227.505 80.9816 229.417 80.9816 231.775V269.136C80.9816 271.494 82.8935 273.406 85.252 273.406Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M82.125 273.406H133.541C135.9 273.406 137.812 271.494 137.812 269.136V231.775C137.812 229.417 135.9 227.505 133.541 227.505H82.125C79.7666 227.505 77.8547 229.417 77.8547 231.775V269.136C77.8547 271.494 79.7666 273.406 82.125 273.406Z"
        fill="#177617"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M77.8851 259.72C72.7707 259.72 68.623 255.572 68.623 250.457C68.623 245.343 72.7707 241.195 77.8851 241.195V259.72Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.5151 251.272C74.9636 251.272 75.3271 250.909 75.3271 250.46C75.3271 250.012 74.9636 249.648 74.5151 249.648C74.0667 249.648 73.7031 250.012 73.7031 250.46C73.7031 250.909 74.0667 251.272 74.5151 251.272Z"
        fill="#0E4D0D"
      />
      <mask
        id="mask0_21779_444667"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="77"
        y="227"
        width="61"
        height="47"
      >
        <path
          d="M82.125 273.398H133.541C135.9 273.398 137.812 271.487 137.812 269.128V231.767C137.812 229.409 135.9 227.497 133.541 227.497H82.125C79.7666 227.497 77.8547 229.409 77.8547 231.767V269.128C77.8547 271.487 79.7666 273.398 82.125 273.398Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_21779_444667)">
        <path
          d="M159.396 290.955H110.138C105.911 290.955 102.538 287.433 102.719 283.209L104.36 245.241C104.877 233.251 104.877 221.24 104.36 209.25L103.207 182.573C102.757 172.196 111.052 163.535 121.439 163.535H148.092C158.481 163.535 166.774 172.196 166.324 182.573L165.17 209.25C164.653 221.24 164.653 233.251 165.17 245.241L166.812 283.209C166.993 287.433 163.619 290.955 159.393 290.955H159.396Z"
          stroke="#209E20"
          strokeWidth="0.6"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M82.125 273.406H133.541C135.9 273.406 137.812 271.494 137.812 269.136V231.775C137.812 229.417 135.9 227.505 133.541 227.505H82.125C79.7666 227.505 77.8547 229.417 77.8547 231.775V269.136C77.8547 271.494 79.7666 273.406 82.125 273.406Z"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M619.993 354.425V136.472C619.993 131.215 615.731 126.953 610.474 126.953H193.305C188.048 126.953 183.786 131.215 183.786 136.472V354.396L619.993 354.425Z"
        fill="#F9F3E9"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M308.772 275.283H282.099C276.082 275.283 271.207 270.405 271.207 264.391V207.668H280.726V263.135C280.726 264.587 281.903 265.764 283.355 265.764H308.772V275.283Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M280.727 207.668V263.135C280.727 264.587 281.904 265.764 283.355 265.764H308.773"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M308.772 268.138H283.042C280.449 268.138 278.349 266.035 278.349 263.444V258.414"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M275.969 214.979V207.668"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M273.589 258.411V214.969"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M308.772 275.283H282.099C276.082 275.283 271.207 270.405 271.207 264.391V207.668"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M242.331 179.113H215.658C209.641 179.113 204.766 183.991 204.766 190.005V246.729H214.285V191.261C214.285 189.81 215.462 188.632 216.914 188.632H242.331V179.113Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M214.281 246.725V191.258C214.281 189.806 215.458 188.629 216.91 188.629H242.327"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M242.331 186.25H216.601C214.007 186.25 211.907 188.353 211.907 190.944V211.261"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M242.331 179.109H215.658C209.641 179.109 204.766 183.987 204.766 190.001V246.725"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M430.162 275.099H456.836C462.853 275.099 467.728 270.221 467.728 264.207V184.195H458.208V262.954C458.208 264.406 457.031 265.583 455.58 265.583H430.162V275.102V275.099Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M458.208 184.195V262.954C458.208 264.406 457.031 265.583 455.58 265.583H430.162"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M430.162 267.95H455.892C458.486 267.95 460.586 265.847 460.586 263.256V229.637"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M462.967 195.514V184.195"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M465.346 229.641V195.508"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M430.162 275.099H456.836C462.853 275.099 467.728 270.221 467.728 264.207V184.195"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M542.139 249.838H515.465C509.448 249.838 504.573 244.96 504.573 238.946V182.223H514.092V237.69C514.092 239.142 515.27 240.319 516.721 240.319H542.139V249.838Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M514.093 182.219V237.686C514.093 239.138 515.27 240.315 516.722 240.315H542.139"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M542.139 242.701H516.409C513.815 242.701 511.715 240.598 511.715 238.007V224.062"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M506.955 224.054V182.219"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M542.139 249.834H515.465C509.448 249.834 504.573 244.956 504.573 238.942V182.219"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M496.263 316.113H457.725C456.264 316.113 455.079 317.298 455.079 318.76V331.86C455.079 333.321 456.264 334.506 457.725 334.506H496.263C497.725 334.506 498.91 333.321 498.91 331.86V318.76C498.91 317.298 497.725 316.113 496.263 316.113Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M494.043 316.113H455.505C454.043 316.113 452.858 317.298 452.858 318.76V331.86C452.858 333.321 454.043 334.506 455.505 334.506H494.043C495.504 334.506 496.689 333.321 496.689 331.86V318.76C496.689 317.298 495.504 316.113 494.043 316.113Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M480.222 320.203H478.244V331.592H480.222V320.203Z"
        fill="#0E4D0D"
      />
      <path
        d="M483.174 322.43H481.196V331.584H483.174V322.43Z"
        fill="#0E4D0D"
      />
      <path
        d="M486.13 318.938H484.152V331.594H486.13V318.938Z"
        fill="#0E4D0D"
      />
      <path
        d="M489.086 321.355H487.108V331.587H489.086V321.355Z"
        fill="#0E4D0D"
      />
      <path
        d="M492.04 323.977H490.062V331.585H492.04V323.977Z"
        fill="#0E4D0D"
      />
      <path
        d="M476.478 331.598H493.807"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M456.548 331.596C456.548 327.168 460.138 323.578 464.566 323.578C468.994 323.578 472.583 327.168 472.583 331.596H456.551H456.548Z"
        fill="#B0E4AB"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M464.565 331.605L468.941 328.395"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M496.263 292.262H457.725C456.264 292.262 455.079 293.447 455.079 294.908V308.008C455.079 309.47 456.264 310.654 457.725 310.654H496.263C497.725 310.654 498.91 309.47 498.91 308.008V294.908C498.91 293.447 497.725 292.262 496.263 292.262Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M494.043 292.262H455.505C454.043 292.262 452.858 293.447 452.858 294.908V308.008C452.858 309.47 454.043 310.654 455.505 310.654H494.043C495.504 310.654 496.689 309.47 496.689 308.008V294.908C496.689 293.447 495.504 292.262 494.043 292.262Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M480.222 302.719H478.244V307.743H480.222V302.719Z"
        fill="#0E4D0D"
      />
      <path
        d="M483.174 300.777H481.196V307.744H483.174V300.777Z"
        fill="#0E4D0D"
      />
      <path
        d="M486.13 305.09H484.152V307.754H486.13V305.09Z"
        fill="#0E4D0D"
      />
      <path
        d="M489.086 302.719H487.108V307.743H489.086V302.719Z"
        fill="#0E4D0D"
      />
      <path
        d="M492.04 299.727H490.062V307.744H492.04V299.727Z"
        fill="#0E4D0D"
      />
      <path
        d="M476.478 307.75H493.807"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M456.548 307.744C456.548 303.316 460.138 299.727 464.566 299.727C468.994 299.727 472.583 303.316 472.583 307.744H456.551H456.548Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M464.566 307.75L461.484 303.141"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M71.1539 290.996H183.786V354.449H61.6377V300.515C61.6377 295.261 65.9022 290.996 71.1568 290.996H71.1539Z"
        fill="#F9F3E9"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M619.992 290.996H725.456C730.711 290.996 734.975 295.261 734.975 300.515V354.449H619.992V290.996Z"
        fill="#F9F3E9"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M392.149 63.668H236.688C233.959 63.668 231.746 65.8806 231.746 68.6101V202.748C231.746 205.478 233.959 207.691 236.688 207.691H392.149C394.878 207.691 397.091 205.478 397.091 202.748V68.6101C397.091 65.8806 394.878 63.668 392.149 63.668Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M388.342 63.668H232.349C229.62 63.668 227.407 65.8806 227.407 68.6101V202.748C227.407 205.478 229.62 207.691 232.349 207.691H388.342C391.071 207.691 393.284 205.478 393.284 202.748V68.6101C393.284 65.8806 391.071 63.668 388.342 63.668Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M199.003 323.961H195.472C194.277 323.961 193.308 324.93 193.308 326.125V335.119C193.308 336.314 194.277 337.283 195.472 337.283H199.003C200.199 337.283 201.168 336.314 201.168 335.119V326.125C201.168 324.93 200.199 323.961 199.003 323.961Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M197.24 330.61L194.398 310.754"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M194.397 314.691C196.569 314.691 198.329 312.931 198.329 310.76C198.329 308.588 196.569 306.828 194.397 306.828C192.226 306.828 190.466 308.588 190.466 310.76C190.466 312.931 192.226 314.691 194.397 314.691Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M246.866 298.668H208.769C207.572 298.668 206.602 299.638 206.602 300.835V314.517C206.602 315.714 207.572 316.684 208.769 316.684H246.866C248.063 316.684 249.033 315.714 249.033 314.517V300.835C249.033 299.638 248.063 298.668 246.866 298.668Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M232.421 322.094H207.684C207.086 322.094 206.601 322.579 206.601 323.177V336.199C206.601 336.797 207.086 337.282 207.684 337.282H232.421C233.02 337.282 233.505 336.797 233.505 336.199V323.177C233.505 322.579 233.02 322.094 232.421 322.094Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M211.982 322.098V337.283"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M217.362 322.098V337.283"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M222.744 322.098V337.283"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M228.123 322.098V337.283"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M233.505 327.164H206.598"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M233.505 332.227H206.598"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M239.283 327.149C240.68 327.149 241.813 326.016 241.813 324.619C241.813 323.222 240.68 322.09 239.283 322.09C237.886 322.09 236.754 323.222 236.754 324.619C236.754 326.016 237.886 327.149 239.283 327.149Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M246.506 327.149C247.903 327.149 249.036 326.016 249.036 324.619C249.036 323.222 247.903 322.09 246.506 322.09C245.109 322.09 243.977 323.222 243.977 324.619C243.977 326.016 245.109 327.149 246.506 327.149Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M588.072 207.852H538.332C535.735 207.852 533.63 209.957 533.63 212.554V277.766C533.63 280.363 535.735 282.468 538.332 282.468H588.072C590.669 282.468 592.775 280.363 592.775 277.766V212.554C592.775 209.957 590.669 207.852 588.072 207.852Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M584.45 207.852H534.203C531.605 207.852 529.5 209.957 529.5 212.554V277.766C529.5 280.363 531.605 282.468 534.203 282.468H584.45C587.048 282.468 589.153 280.363 589.153 277.766V212.554C589.153 209.957 587.048 207.852 584.45 207.852Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M587.653 37.1133H426.672C423.844 37.1133 421.552 39.4057 421.552 42.2336V181.136C421.552 183.964 423.844 186.256 426.672 186.256H587.653C590.481 186.256 592.774 183.964 592.774 181.136V42.2336C592.774 39.4057 590.481 37.1133 587.653 37.1133Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M583.71 37.1133H422.177C419.349 37.1133 417.057 39.4057 417.057 42.2336V181.136C417.057 183.964 419.349 186.256 422.177 186.256H583.71C586.538 186.256 588.83 183.964 588.83 181.136V42.2336C588.83 39.4057 586.538 37.1133 583.71 37.1133Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M514.104 107.946L526.054 101.958L538.006 97.7109"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M538.006 97.7109L549.958 89.0651L561.907 74.0664"
        stroke="#F9F3E9"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M514.103 109.782C515.106 109.782 515.92 108.969 515.92 107.965C515.92 106.962 515.106 106.148 514.103 106.148C513.1 106.148 512.286 106.962 512.286 107.965C512.286 108.969 513.1 109.782 514.103 109.782Z"
        fill="#0E4D0D"
      />
      <path
        d="M526.052 103.782C527.056 103.782 527.869 102.969 527.869 101.965C527.869 100.962 527.056 100.148 526.052 100.148C525.049 100.148 524.235 100.962 524.235 101.965C524.235 102.969 525.049 103.782 526.052 103.782Z"
        fill="#0E4D0D"
      />
      <path
        d="M549.957 90.8953C550.961 90.8953 551.774 90.0819 551.774 89.0785C551.774 88.0751 550.961 87.2617 549.957 87.2617C548.954 87.2617 548.141 88.0751 548.141 89.0785C548.141 90.0819 548.954 90.8953 549.957 90.8953Z"
        fill="#F9F3E9"
      />
      <path
        d="M561.908 75.8953C562.911 75.8953 563.724 75.0819 563.724 74.0785C563.724 73.0751 562.911 72.2617 561.908 72.2617C560.904 72.2617 560.091 73.0751 560.091 74.0785C560.091 75.0819 560.904 75.8953 561.908 75.8953Z"
        fill="#F9F3E9"
      />
      <path
        d="M538.004 99.5398C539.008 99.5398 539.821 98.7264 539.821 97.723C539.821 96.7197 539.008 95.9062 538.004 95.9062C537.001 95.9062 536.188 96.7197 536.188 97.723C536.188 98.7264 537.001 99.5398 538.004 99.5398Z"
        fill="#0E4D0D"
      />
      <path
        d="M507.789 75.043V114.276H547.025"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M545.553 137.883H507.789V144.504H545.553V137.883Z"
        fill="#F9F3E9"
      />
      <path
        d="M537.036 137.883H507.789V144.504H537.036V137.883Z"
        fill="#0E4D0D"
      />
      <path
        d="M545.553 149.168H507.789V155.79H545.553V149.168Z"
        fill="#F9F3E9"
      />
      <path
        d="M533.046 149.168H507.789V155.79H533.046V149.168Z"
        fill="#0E4D0D"
      />
      <path
        d="M507.789 126.41V165.643"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M451.972 60.8299L456.715 56.2266H466.576L471.41 60.824C472.47 61.8317 473.069 63.2308 473.069 64.6913V103.554C473.069 104.345 472.429 104.985 471.638 104.985H451.782C450.99 104.985 450.351 104.345 450.351 103.554V64.6621C450.351 63.2191 450.935 61.8376 451.972 60.8328V60.8299Z"
        fill="#B0E4AB"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M458.572 47.4766H464.723C465.748 47.4766 466.578 48.309 466.578 49.3313V56.2304H456.717V49.3313C456.717 48.3061 457.549 47.4766 458.572 47.4766Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M456.716 51.7539H466.708"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M462.314 51.7539C462.314 52.674 461.569 53.4188 460.649 53.4188C459.729 53.4188 458.984 52.674 458.984 51.7539"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M465.899 58.3906L467.908 60.961C468.642 61.8986 469.039 63.0553 469.039 64.247V103.559C469.039 104.351 468.399 104.99 467.608 104.99H464.117"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M475.871 104.977H447.55V113.05H475.871V104.977Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M438.517 113.055H484.903"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M471.432 121.121H439.145V124.977H471.432V121.121Z"
        fill="#0E4D0D"
      />
      <path
        d="M467.077 126.426H439.145V130.281H467.077V126.426Z"
        fill="#0E4D0D"
      />
      <path
        d="M469.037 136.23H447.875V139.055H469.037V136.23Z"
        fill="#0E4D0D"
      />
      <path
        d="M445.153 136.397C445.304 136.765 445.386 137.169 445.386 137.592C445.386 139.333 443.973 140.747 442.232 140.747C440.491 140.747 439.077 139.333 439.077 137.592C439.077 135.851 440.491 134.438 442.232 134.438C442.775 134.438 443.289 134.575 443.736 134.817"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M445.932 133.773L442.121 138.856L440.315 137.5"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M461.124 145.031H447.875V147.856H461.124V145.031Z"
        fill="#0E4D0D"
      />
      <path
        d="M445.153 145.206C445.304 145.574 445.386 145.977 445.386 146.401C445.386 148.141 443.973 149.555 442.232 149.555C440.491 149.555 439.077 148.141 439.077 146.401C439.077 144.66 440.491 143.246 442.232 143.246C442.775 143.246 443.289 143.383 443.736 143.626"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M445.932 142.574L442.121 147.657L440.315 146.301"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M466.124 153.844H447.874V156.668H466.124V153.844Z"
        fill="#0E4D0D"
      />
      <path
        d="M445.152 153.999C445.303 154.367 445.385 154.77 445.385 155.194C445.385 156.934 443.972 158.348 442.231 158.348C440.49 158.348 439.076 156.934 439.076 155.194C439.076 153.453 440.49 152.039 442.231 152.039C442.774 152.039 443.288 152.176 443.735 152.419"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M445.932 151.375L442.121 156.457L440.315 155.102"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M466.31 163.418H464.35V174.704H466.31V163.418Z"
        fill="#0E4D0D"
      />
      <path
        d="M469.237 165.637H467.277V174.709H469.237V165.637Z"
        fill="#0E4D0D"
      />
      <path
        d="M472.167 162.16H470.207V174.705H472.167V162.16Z"
        fill="#0E4D0D"
      />
      <path
        d="M475.093 164.555H473.133V174.696H475.093V164.555Z"
        fill="#0E4D0D"
      />
      <path
        d="M478.023 167.16H476.063V174.702H478.023V167.16Z"
        fill="#0E4D0D"
      />
      <path
        d="M462.597 174.699H479.774"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M442.849 174.703C442.849 170.315 446.406 166.758 450.793 166.758C455.181 166.758 458.738 170.315 458.738 174.703H442.849Z"
        fill="#F9F3E9"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M450.792 174.711L455.13 171.527"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M320.492 128.732V138.116C320.492 138.863 321.098 139.469 321.845 139.469H331.229C331.976 139.469 332.582 138.863 332.582 138.116V128.732C332.582 127.985 331.976 127.379 331.229 127.379H321.845C321.098 127.379 320.492 127.985 320.492 128.732Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M343.883 153.466V162.851C343.883 163.598 344.488 164.203 345.235 164.203H354.62C355.367 164.203 355.972 163.598 355.972 162.851V153.466C355.972 152.719 355.367 152.114 354.62 152.114H345.235C344.488 152.114 343.883 152.719 343.883 153.466Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M350.479 149.661V159.046C350.479 159.793 351.085 160.398 351.832 160.398H361.217C361.964 160.398 362.569 159.793 362.569 159.046V149.661C362.569 148.914 361.964 148.309 361.217 148.309H351.832C351.085 148.309 350.479 148.914 350.479 149.661Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M365.397 136.986V146.37C365.397 147.117 366.003 147.723 366.75 147.723H376.135C376.881 147.723 377.487 147.117 377.487 146.37V136.986C377.487 136.239 376.881 135.633 376.135 135.633H366.75C366.003 135.633 365.397 136.239 365.397 136.986Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M344.436 133.411V142.796C344.436 143.543 345.041 144.148 345.788 144.148H355.173C355.92 144.148 356.525 143.543 356.525 142.796V133.411C356.525 132.664 355.92 132.059 355.173 132.059H345.788C345.041 132.059 344.436 132.664 344.436 133.411Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M344.436 119.38V128.765C344.436 129.512 345.041 130.117 345.788 130.117H355.173C355.92 130.117 356.525 129.512 356.525 128.765V119.38C356.525 118.633 355.92 118.028 355.173 118.028H345.788C345.041 118.028 344.436 118.633 344.436 119.38Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M328.259 102.321V111.706C328.259 112.453 328.864 113.059 329.611 113.059H338.996C339.743 113.059 340.348 112.453 340.348 111.706V102.321C340.348 101.575 339.743 100.969 338.996 100.969H329.611C328.864 100.969 328.259 101.575 328.259 102.321Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M337.839 104.732V114.116C337.839 114.863 338.444 115.469 339.191 115.469H348.576C349.323 115.469 349.928 114.863 349.928 114.116V104.732C349.928 103.985 349.323 103.379 348.576 103.379H339.191C338.444 103.379 337.839 103.985 337.839 104.732Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M331.161 109.052V118.437C331.161 119.184 331.767 119.789 332.513 119.789H341.898C342.645 119.789 343.251 119.184 343.251 118.437V109.052C343.251 108.305 342.645 107.7 341.898 107.7H332.513C331.767 107.7 331.161 108.305 331.161 109.052Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M347.104 181.689V191.073C347.104 191.82 347.709 192.426 348.456 192.426H357.841C358.588 192.426 359.193 191.82 359.193 191.073V181.689C359.193 180.942 358.588 180.336 357.841 180.336H348.456C347.709 180.336 347.104 180.942 347.104 181.689Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M369.622 152.864V162.249C369.622 162.996 370.228 163.602 370.974 163.602H380.359C381.106 163.602 381.712 162.996 381.712 162.249V152.864C381.712 152.118 381.106 151.512 380.359 151.512H370.974C370.228 151.512 369.622 152.118 369.622 152.864Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M374.662 149.138V158.523C374.662 159.27 375.268 159.875 376.014 159.875H385.399C386.146 159.875 386.752 159.27 386.752 158.523V149.138C386.752 148.391 386.146 147.785 385.399 147.785H376.014C375.268 147.785 374.662 148.391 374.662 149.138Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M253.77 149.196V158.581C253.77 159.328 254.375 159.934 255.122 159.934H264.507C265.254 159.934 265.859 159.328 265.859 158.581V149.196C265.859 148.45 265.254 147.844 264.507 147.844H255.122C254.375 147.844 253.77 148.45 253.77 149.196Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M262.787 157.216V166.601C262.787 167.348 263.393 167.953 264.139 167.953H273.524C274.271 167.953 274.877 167.348 274.877 166.601V157.216C274.877 156.469 274.271 155.864 273.524 155.864H264.139C263.393 155.864 262.787 156.469 262.787 157.216Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M255.558 169.29V178.675C255.558 179.422 256.163 180.027 256.91 180.027H266.295C267.042 180.027 267.647 179.422 267.647 178.675V169.29C267.647 168.543 267.042 167.938 266.295 167.938H256.91C256.163 167.938 255.558 168.543 255.558 169.29Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M270.183 173.708V183.093C270.183 183.84 270.788 184.445 271.535 184.445H280.92C281.667 184.445 282.272 183.84 282.272 183.093V173.708C282.272 172.961 281.667 172.356 280.92 172.356H271.535C270.788 172.356 270.183 172.961 270.183 173.708Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M261.168 178.763V188.148C261.168 188.895 261.773 189.5 262.52 189.5H271.905C272.652 189.5 273.257 188.895 273.257 188.148V178.763C273.257 178.016 272.652 177.41 271.905 177.41H262.52C261.773 177.41 261.168 178.016 261.168 178.763Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M239.017 178.185V187.57C239.017 188.316 239.622 188.922 240.369 188.922H249.754C250.501 188.922 251.106 188.316 251.106 187.57V178.185C251.106 177.438 250.501 176.832 249.754 176.832H240.369C239.622 176.832 239.017 177.438 239.017 178.185Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M243.848 184.814V194.198C243.848 194.945 244.453 195.551 245.2 195.551H254.585C255.332 195.551 255.937 194.945 255.937 194.198V184.814C255.937 184.067 255.332 183.461 254.585 183.461H245.2C244.453 183.461 243.848 184.067 243.848 184.814Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M276.56 189.837V199.222C276.56 199.969 277.165 200.574 277.912 200.574H287.297C288.044 200.574 288.649 199.969 288.649 199.222V189.837C288.649 189.09 288.044 188.485 287.297 188.485H277.912C277.165 188.485 276.56 189.09 276.56 189.837Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M292.849 184.814V194.198C292.849 194.945 293.454 195.551 294.201 195.551H303.586C304.333 195.551 304.938 194.945 304.938 194.198V184.814C304.938 184.067 304.333 183.461 303.586 183.461H294.201C293.454 183.461 292.849 184.067 292.849 184.814Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M287.889 187.552V196.937C287.889 197.684 288.494 198.289 289.241 198.289H298.626C299.373 198.289 299.978 197.684 299.978 196.937V187.552C299.978 186.805 299.373 186.2 298.626 186.2H289.241C288.494 186.2 287.889 186.805 287.889 187.552Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M293.935 154.845V164.23C293.935 164.977 294.54 165.582 295.287 165.582H304.672C305.419 165.582 306.024 164.977 306.024 164.23V154.845C306.024 154.098 305.419 153.493 304.672 153.493H295.287C294.54 153.493 293.935 154.098 293.935 154.845Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M297.478 169.579V178.964C297.478 179.711 298.083 180.316 298.83 180.316H308.215C308.962 180.316 309.567 179.711 309.567 178.964V169.579C309.567 168.832 308.962 168.227 308.215 168.227H298.83C298.083 168.227 297.478 168.832 297.478 169.579Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M290.396 168.138V177.523C290.396 178.27 291.002 178.875 291.749 178.875H301.134C301.881 178.875 302.486 178.27 302.486 177.523V168.138C302.486 167.391 301.881 166.785 301.134 166.785H291.749C291.002 166.785 290.396 167.391 290.396 168.138Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M238.606 146.536V155.921C238.606 156.668 239.212 157.273 239.959 157.273H249.344C250.09 157.273 250.696 156.668 250.696 155.921V146.536C250.696 145.789 250.09 145.184 249.344 145.184H239.959C239.212 145.184 238.606 145.789 238.606 146.536Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M248.813 152.497V161.882C248.813 162.629 249.419 163.234 250.166 163.234H259.551C260.298 163.234 260.903 162.629 260.903 161.882V152.497C260.903 151.75 260.298 151.145 259.551 151.145H250.166C249.419 151.145 248.813 151.75 248.813 152.497Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M261.602 126.653V136.038C261.602 136.785 262.207 137.391 262.954 137.391H272.339C273.086 137.391 273.691 136.785 273.691 136.038V126.653C273.691 125.907 273.086 125.301 272.339 125.301H262.954C262.207 125.301 261.602 125.907 261.602 126.653Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M235.777 133.236V142.62C235.777 143.367 236.383 143.973 237.13 143.973H246.514C247.261 143.973 247.867 143.367 247.867 142.62V133.236C247.867 132.489 247.261 131.883 246.514 131.883H237.13C236.383 131.883 235.777 132.489 235.777 133.236Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M281.214 119.693V129.077C281.214 129.824 281.819 130.43 282.566 130.43H291.951C292.698 130.43 293.303 129.824 293.303 129.077V119.693C293.303 118.946 292.698 118.34 291.951 118.34H282.566C281.819 118.34 281.214 118.946 281.214 119.693Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M245.092 105.251V114.636C245.092 115.383 245.697 115.988 246.444 115.988H255.829C256.576 115.988 257.181 115.383 257.181 114.636V105.251C257.181 104.504 256.576 103.899 255.829 103.899H246.444C245.697 103.899 245.092 104.504 245.092 105.251Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M250.697 108.505V117.89C250.697 118.637 251.303 119.242 252.05 119.242H261.434C262.181 119.242 262.787 118.637 262.787 117.89V108.505C262.787 107.758 262.181 107.153 261.434 107.153H252.05C251.303 107.153 250.697 107.758 250.697 108.505Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M248.331 81.509V90.8937C248.331 91.6406 248.937 92.2461 249.683 92.2461H259.068C259.815 92.2461 260.421 91.6406 260.421 90.8937V81.509C260.421 80.7621 259.815 80.1566 259.068 80.1566H249.683C248.937 80.1566 248.331 80.7621 248.331 81.509Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M330.511 149.935V159.32C330.511 160.066 331.116 160.672 331.863 160.672H341.248C341.995 160.672 342.6 160.066 342.6 159.32V149.935C342.6 149.188 341.995 148.582 341.248 148.582H331.863C331.116 148.582 330.511 149.188 330.511 149.935Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M320.492 138.732V148.116C320.492 148.863 321.098 149.469 321.845 149.469H331.229C331.976 149.469 332.582 148.863 332.582 148.116V138.732C332.582 137.985 331.976 137.379 331.229 137.379H321.845C321.098 137.379 320.492 137.985 320.492 138.732Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M369.377 112.505V121.89C369.377 122.637 369.982 123.242 370.729 123.242H380.114C380.861 123.242 381.466 122.637 381.466 121.89V112.505C381.466 111.758 380.861 111.153 380.114 111.153H370.729C369.982 111.153 369.377 111.758 369.377 112.505Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M372.562 115.685V125.07C372.562 125.816 373.167 126.422 373.914 126.422H383.299C384.046 126.422 384.651 125.816 384.651 125.07V115.685C384.651 114.938 384.046 114.332 383.299 114.332H373.914C373.167 114.332 372.562 114.938 372.562 115.685Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M364.619 119.974V129.359C364.619 130.105 365.225 130.711 365.972 130.711H375.356C376.103 130.711 376.709 130.105 376.709 129.359V119.974C376.709 119.227 376.103 118.621 375.356 118.621H365.972C365.225 118.621 364.619 119.227 364.619 119.974Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M371.44 78.7863V88.1711C371.44 88.918 372.046 89.5234 372.793 89.5234H382.178C382.924 89.5234 383.53 88.918 383.53 88.1711V78.7863C383.53 78.0394 382.924 77.4339 382.178 77.4339H372.793C372.046 77.4339 371.44 78.0394 371.44 78.7863Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M361.912 88.5793V97.964C361.912 98.7109 362.518 99.3164 363.264 99.3164H372.649C373.396 99.3164 374.002 98.7109 374.002 97.964V88.5793C374.002 87.8324 373.396 87.2269 372.649 87.2269H363.264C362.518 87.2269 361.912 87.8324 361.912 88.5793Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M346.514 77.0324V86.4172C346.514 87.1641 347.119 87.7695 347.866 87.7695H357.251C357.998 87.7695 358.603 87.1641 358.603 86.4172V77.0324C358.603 76.2855 357.998 75.68 357.251 75.68H347.866C347.119 75.68 346.514 76.2855 346.514 77.0324Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M350.746 70.9894V80.3742C350.746 81.1211 351.352 81.7266 352.098 81.7266H361.483C362.23 81.7266 362.836 81.1211 362.836 80.3742V70.9894C362.836 70.2425 362.23 69.637 361.483 69.637H352.098C351.352 69.637 350.746 70.2425 350.746 70.9894Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M329.233 67.7043V77.089C329.233 77.8359 329.839 78.4414 330.586 78.4414H339.971C340.717 78.4414 341.323 77.8359 341.323 77.089V67.7043C341.323 66.9574 340.717 66.3519 339.971 66.3519H330.586C329.839 66.3519 329.233 66.9574 329.233 67.7043Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M254.376 70.9074V80.2922C254.376 81.0391 254.981 81.6445 255.728 81.6445H265.113C265.86 81.6445 266.465 81.0391 266.465 80.2922V70.9074C266.465 70.1605 265.86 69.555 265.113 69.555H255.728C254.981 69.555 254.376 70.1605 254.376 70.9074Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M289.197 120.607V129.991C289.197 130.738 289.803 131.344 290.55 131.344H299.934C300.681 131.344 301.287 130.738 301.287 129.991V120.607C301.287 119.86 300.681 119.254 299.934 119.254H290.55C289.803 119.254 289.197 119.86 289.197 120.607Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M299.288 110.775V120.159C299.288 120.906 299.894 121.512 300.64 121.512H310.025C310.772 121.512 311.378 120.906 311.378 120.159V110.775C311.378 110.028 310.772 109.422 310.025 109.422H300.64C299.894 109.422 299.288 110.028 299.288 110.775Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M310.649 153.954V163.339C310.649 164.086 311.255 164.691 312.002 164.691H321.387C322.133 164.691 322.739 164.086 322.739 163.339V153.954C322.739 153.207 322.133 152.602 321.387 152.602H312.002C311.255 152.602 310.649 153.207 310.649 153.954Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M323.911 165.364V174.749C323.911 175.496 324.517 176.102 325.263 176.102H334.648C335.395 176.102 336.001 175.496 336.001 174.749V165.364C336.001 164.618 335.395 164.012 334.648 164.012H325.263C324.517 164.012 323.911 164.618 323.911 165.364Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M316.379 177.45V186.835C316.379 187.582 316.984 188.188 317.731 188.188H327.116C327.863 188.188 328.468 187.582 328.468 186.835V177.45C328.468 176.703 327.863 176.098 327.116 176.098H317.731C316.984 176.098 316.379 176.703 316.379 177.45Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M308.773 183.786V193.171C308.773 193.918 309.379 194.523 310.126 194.523H319.511C320.257 194.523 320.863 193.918 320.863 193.171V183.786C320.863 183.039 320.257 182.434 319.511 182.434H310.126C309.379 182.434 308.773 183.039 308.773 183.786Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M323.329 191.97V201.355C323.329 202.102 323.935 202.707 324.681 202.707H334.066C334.813 202.707 335.419 202.102 335.419 201.355V191.97C335.419 191.223 334.813 190.618 334.066 190.618H324.681C323.935 190.618 323.329 191.223 323.329 191.97Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M317.868 158.907V168.292C317.868 169.039 318.474 169.645 319.221 169.645H328.605C329.352 169.645 329.958 169.039 329.958 168.292V158.907C329.958 158.16 329.352 157.555 328.605 157.555H319.221C318.474 157.555 317.868 158.16 317.868 158.907Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M357.531 188.411V197.796C357.531 198.543 358.137 199.148 358.884 199.148H368.268C369.015 199.148 369.621 198.543 369.621 197.796V188.411C369.621 187.664 369.015 187.059 368.268 187.059H358.884C358.137 187.059 357.531 187.664 357.531 188.411Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M371.444 180.544V189.929C371.444 190.676 372.05 191.281 372.797 191.281H382.181C382.928 191.281 383.534 190.676 383.534 189.929V180.544C383.534 179.797 382.928 179.192 382.181 179.192H372.797C372.05 179.192 371.444 179.797 371.444 180.544Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M360.238 170.583V179.968C360.238 180.715 360.844 181.32 361.591 181.32H370.975C371.722 181.32 372.328 180.715 372.328 179.968V170.583C372.328 169.836 371.722 169.231 370.975 169.231H361.591C360.844 169.231 360.238 169.836 360.238 170.583Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M339.109 175.333V184.718C339.109 185.465 339.715 186.07 340.462 186.07H349.847C350.593 186.07 351.199 185.465 351.199 184.718V175.333C351.199 174.586 350.593 173.981 349.847 173.981H340.462C339.715 173.981 339.109 174.586 339.109 175.333Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M365.84 191.97V201.355C365.84 202.102 366.445 202.707 367.192 202.707H376.577C377.324 202.707 377.929 202.102 377.929 201.355V191.97C377.929 191.223 377.324 190.618 376.577 190.618H367.192C366.445 190.618 365.84 191.223 365.84 191.97Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M298.255 134.771V144.155C298.255 144.902 298.86 145.508 299.607 145.508H308.992C309.739 145.508 310.344 144.902 310.344 144.155V134.771C310.344 134.024 309.739 133.418 308.992 133.418H299.607C298.86 133.418 298.255 134.024 298.255 134.771Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M251.551 118.458V127.843C251.551 128.59 252.156 129.195 252.903 129.195H262.288C263.035 129.195 263.64 128.59 263.64 127.843V118.458C263.64 117.711 263.035 117.106 262.288 117.106H252.903C252.156 117.106 251.551 117.711 251.551 118.458Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M269.517 99.2043V108.589C269.517 109.336 270.122 109.941 270.869 109.941H280.254C281.001 109.941 281.606 109.336 281.606 108.589V99.2043C281.606 98.4574 281.001 97.8519 280.254 97.8519H270.869C270.122 97.8519 269.517 98.4574 269.517 99.2043Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M269.517 103.001V112.386C269.517 113.133 270.122 113.738 270.869 113.738H280.254C281.001 113.738 281.606 113.133 281.606 112.386V103.001C281.606 102.254 281.001 101.649 280.254 101.649H270.869C270.122 101.649 269.517 102.254 269.517 103.001Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M239.46 88.0636V97.4484C239.46 98.1953 240.065 98.8008 240.812 98.8008H250.197C250.944 98.8008 251.549 98.1953 251.549 97.4484V88.0636C251.549 87.3167 250.944 86.7113 250.197 86.7113H240.812C240.065 86.7113 239.46 87.3167 239.46 88.0636Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M272.383 78.8019V88.1867C272.383 88.9336 272.988 89.5391 273.735 89.5391H283.12C283.867 89.5391 284.472 88.9336 284.472 88.1867V78.8019C284.472 78.055 283.867 77.4495 283.12 77.4495H273.735C272.988 77.4495 272.383 78.055 272.383 78.8019Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M244.106 159.638V169.023C244.106 169.77 244.712 170.375 245.459 170.375H254.844C255.59 170.375 256.196 169.77 256.196 169.023V159.638C256.196 158.891 255.59 158.285 254.844 158.285H245.459C244.712 158.285 244.106 158.891 244.106 159.638Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M277.645 141.872V151.257C277.645 152.004 278.25 152.609 278.997 152.609H288.382C289.129 152.609 289.734 152.004 289.734 151.257V141.872C289.734 141.125 289.129 140.52 288.382 140.52H278.997C278.25 140.52 277.645 141.125 277.645 141.872Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M310.648 97.1818C317.252 97.1818 322.606 91.828 322.606 85.2237C322.606 78.6194 317.252 73.2656 310.648 73.2656C304.043 73.2656 298.689 78.6194 298.689 85.2237C298.689 91.828 304.043 97.1818 310.648 97.1818Z"
        fill="#0E4D0D"
      />
      <path
        d="M311.378 82.6152C311.135 82.8956 310.913 83.1847 310.688 83.471C310.665 83.5002 310.65 83.509 310.621 83.4739C310.393 83.2052 310.165 82.9365 309.935 82.6677C309.891 82.6152 309.935 82.6093 309.961 82.5977C310.244 82.475 310.542 82.4312 310.849 82.4633C311.03 82.4837 311.208 82.5275 311.378 82.6123V82.6152Z"
        fill="#FFA366"
      />
      <path
        d="M318.662 83.5601C317.993 82.1318 316.869 81.3198 315.285 81.1825C314.678 81.1299 314.085 81.2263 313.515 81.4395C312.706 81.7433 312.049 82.2515 311.503 82.9146C311.234 83.2417 310.971 83.5718 310.708 83.9047C310.673 83.9486 310.656 83.9602 310.612 83.9077C310.425 83.6798 310.232 83.4549 310.042 83.23C309.689 82.8123 309.336 82.3917 308.897 82.0529C307.767 81.1737 306.505 80.9547 305.141 81.3607C304.233 81.6323 303.52 82.1843 302.986 82.9642C302.53 83.6302 302.293 84.3692 302.282 85.1753C302.276 85.5667 302.328 85.9494 302.437 86.3232C302.708 87.2638 303.231 88.0319 304.046 88.5869C304.823 89.1156 305.69 89.3434 306.628 89.2967C307.087 89.2733 307.531 89.1711 307.954 88.99C308.001 88.9695 308.007 88.9579 307.977 88.9111C307.773 88.5957 307.571 88.2802 307.37 87.9648C307.335 87.9093 307.297 87.8888 307.233 87.9093C306.622 88.1079 306.015 88.0845 305.413 87.8742C303.923 87.3572 303.146 85.6485 303.739 84.191C304.236 82.973 305.468 82.2632 306.768 82.4472C307.446 82.5436 308.012 82.8474 308.465 83.3585C308.912 83.8639 309.347 84.3779 309.788 84.8862C309.818 84.9183 309.82 84.9358 309.788 84.9709C309.651 85.1257 309.517 85.2863 309.382 85.4441C309.149 85.7186 308.886 85.9669 308.681 86.2677C308.48 86.5627 308.334 86.884 308.313 87.2462C308.275 87.9034 308.515 88.4467 309.017 88.8673C309.359 89.1536 309.753 89.3054 310.206 89.3025C310.498 89.3025 310.793 89.2967 311.085 89.3025C311.395 89.3113 311.681 89.2295 311.95 89.0864C313.159 88.4496 313.267 87.0067 312.514 86.11C312.189 85.7274 311.859 85.3535 311.529 84.9767C311.491 84.9358 311.491 84.9095 311.529 84.8657C311.804 84.5473 312.078 84.229 312.353 83.9077C312.604 83.6127 312.858 83.3177 313.162 83.0723C314.027 82.3713 314.985 82.2048 316.013 82.6283C316.988 83.0314 317.575 83.7821 317.742 84.8248C317.879 85.6894 317.631 86.4634 317.044 87.1148C316.527 87.6873 315.875 87.994 315.104 88.0407C314.786 88.0612 314.473 88.0232 314.17 87.9326C314.117 87.918 314.091 87.9268 314.062 87.9735C314.003 88.0728 313.939 88.1663 313.875 88.2656C313.717 88.511 313.562 88.7534 313.401 89.0046C313.67 89.1127 313.939 89.1915 314.216 89.2383C314.935 89.3609 315.639 89.3054 316.317 89.0455C317.862 88.4555 318.776 87.3485 318.986 85.6982C319.08 84.9592 318.98 84.2348 318.665 83.5572L318.662 83.5601ZM311.567 86.9512C311.795 87.2229 311.792 87.5763 311.564 87.8333C311.447 87.9648 311.296 88.0203 311.126 88.0407C310.965 88.0582 310.805 88.0524 310.627 88.0524C310.454 88.0407 310.264 88.0699 310.078 88.0232C309.645 87.918 309.441 87.3864 309.698 87.0242C309.864 86.7906 310.069 86.5832 310.256 86.3641C310.378 86.221 310.504 86.0808 310.624 85.9377C310.653 85.9026 310.668 85.9026 310.697 85.9377C310.989 86.2765 311.284 86.6095 311.57 86.9483L311.567 86.9512Z"
        fill="white"
      />
      <path
        d="M310.621 87.7696C310.484 87.7579 310.317 87.7842 310.154 87.7463C309.92 87.6908 309.803 87.4337 309.914 87.2205C309.979 87.1007 310.084 87.0102 310.166 86.905C310.209 86.8495 310.259 86.7999 310.3 86.7444C310.329 86.7035 310.355 86.7035 310.399 86.7269C310.566 86.8203 310.735 86.8203 310.899 86.7269C310.945 86.7006 310.972 86.7064 311.004 86.7473C311.112 86.8758 311.223 86.9985 311.334 87.127C311.465 87.2789 311.471 87.4746 311.36 87.6236C311.284 87.7258 311.17 87.7463 311.054 87.7579C310.916 87.7725 310.779 87.7667 310.615 87.7667L310.621 87.7696Z"
        fill="#FFA366"
      />
      <path
        d="M566.405 234.417C566.89 235.6 567.156 236.893 567.156 238.249C567.156 243.839 562.623 248.373 557.032 248.373C551.441 248.373 546.908 243.839 546.908 238.249C546.908 232.658 551.441 228.125 557.032 228.125C558.779 228.125 560.423 228.569 561.857 229.346"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M568.914 225.969L556.679 242.279L550.887 237.93"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M572.814 262.289H545.025C543.084 262.289 541.511 263.862 541.511 265.803C541.511 267.744 543.084 269.317 545.025 269.317H572.814C574.754 269.317 576.328 267.744 576.328 265.803C576.328 263.862 574.754 262.289 572.814 262.289Z"
        fill="#B0E4AB"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M551.876 299.805L551.879 323.776"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M555.296 306.16H549.778C549.365 306.16 549.03 306.495 549.03 306.908V308.567C549.03 308.98 549.365 309.315 549.778 309.315H555.296C555.709 309.315 556.043 308.98 556.043 308.567V306.908C556.043 306.495 555.709 306.16 555.296 306.16Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M553.975 306.16H548.458C548.045 306.16 547.71 306.495 547.71 306.908V308.567C547.71 308.98 548.045 309.315 548.458 309.315H553.975C554.388 309.315 554.723 308.98 554.723 308.567V306.908C554.723 306.495 554.388 306.16 553.975 306.16Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M562.679 299.805V323.776"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M566.096 315.84H560.579C560.166 315.84 559.831 316.175 559.831 316.588V318.247C559.831 318.66 560.166 318.994 560.579 318.994H566.096C566.509 318.994 566.844 318.66 566.844 318.247V316.588C566.844 316.175 566.509 315.84 566.096 315.84Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M564.776 315.84H559.259C558.846 315.84 558.511 316.175 558.511 316.588V318.247C558.511 318.66 558.846 318.994 559.259 318.994H564.776C565.189 318.994 565.524 318.66 565.524 318.247V316.588C565.524 316.175 565.189 315.84 564.776 315.84Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M573.479 299.805V323.776"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M576.901 308.605H571.384C570.971 308.605 570.636 308.94 570.636 309.353V311.012C570.636 311.425 570.971 311.76 571.384 311.76H576.901C577.314 311.76 577.649 311.425 577.649 311.012V309.353C577.649 308.94 577.314 308.605 576.901 308.605Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M575.579 308.605H570.061C569.648 308.605 569.313 308.94 569.313 309.353V311.012C569.313 311.425 569.648 311.76 570.061 311.76H575.579C575.992 311.76 576.327 311.425 576.327 311.012V309.353C576.327 308.94 575.992 308.605 575.579 308.605Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M532.604 319.892C535.23 317.222 535.194 312.93 532.524 310.305C529.855 307.679 525.562 307.715 522.937 310.385C520.312 313.055 520.348 317.347 523.017 319.972C525.687 322.597 529.979 322.561 532.604 319.892Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M532.55 310.312L528.703 314.159"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M527.758 302.305L527.761 306.043"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M536.795 306.031L534.148 308.68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M536.797 315.055H540.538"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M514.982 315.055H518.721"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M518.724 306.023L521.382 308.679"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M522.868 303.273L523.844 305.625"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M531.675 305.628L532.65 303.273"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M539.556 310.172L537.205 311.147"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M515.946 310.172L518.312 311.153"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M592.721 305.363H589.563C588.494 305.363 587.627 306.23 587.627 307.3V315.341C587.627 316.41 588.494 317.278 589.563 317.278H592.721C593.79 317.278 594.658 316.41 594.658 315.341V307.3C594.658 306.23 593.79 305.363 592.721 305.363Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M591.141 311.316L589.047 325.953"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M589.047 329.479C590.989 329.479 592.564 327.904 592.564 325.962C592.564 324.02 590.989 322.445 589.047 322.445C587.105 322.445 585.53 324.02 585.53 325.962C585.53 327.904 587.105 329.479 589.047 329.479Z"
        fill="#F3E0C8"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M433.986 219.352H311.83C309.057 219.352 306.809 221.6 306.809 224.373V328.978C306.809 331.751 309.057 333.999 311.83 333.999H433.986C436.76 333.999 439.007 331.751 439.007 328.978V224.373C439.007 221.6 436.76 219.352 433.986 219.352Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M430.12 219.352H307.422C304.649 219.352 302.401 221.6 302.401 224.373V328.978C302.401 331.751 304.649 333.999 307.422 333.999H430.12C432.893 333.999 435.141 331.751 435.141 328.978V224.373C435.141 221.6 432.893 219.352 430.12 219.352Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M329.316 272.773H316.003C314.861 272.773 313.949 271.821 313.999 270.679L314.443 260.418C314.583 257.176 314.583 253.93 314.443 250.691L314.13 243.483C314.011 240.678 316.251 238.336 319.058 238.336H326.261C329.068 238.336 331.311 240.676 331.188 243.483L330.876 250.691C330.736 253.933 330.736 257.179 330.876 260.418L331.32 270.679C331.369 271.821 330.458 272.773 329.316 272.773Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M320.552 232.336H324.772C325.476 232.336 326.046 232.906 326.046 233.609V238.344H319.278V233.609C319.278 232.906 319.848 232.336 320.552 232.336Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M324.464 238.344V233.609C324.464 232.906 323.894 232.336 323.19 232.336"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M329.316 272.773H316.003C314.861 272.773 313.949 271.821 313.999 270.679L314.443 260.418C314.583 257.176 314.583 253.93 314.443 250.691L314.13 243.483C314.011 240.678 316.251 238.336 319.058 238.336H326.261C329.068 238.336 331.311 240.676 331.188 243.483L330.876 250.691C330.736 253.933 330.736 257.179 330.876 260.418L331.32 270.679C331.369 271.821 330.458 272.773 329.316 272.773Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M324.463 238.336C327.27 238.336 329.513 240.676 329.39 243.483L329.078 250.691C328.938 253.933 328.938 257.179 329.078 260.418L329.522 270.679C329.571 271.821 328.66 272.773 327.518 272.773"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M319.278 235.277H326.134"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M322.954 235.277C322.954 235.853 322.489 236.317 321.914 236.317C321.338 236.317 320.874 235.853 320.874 235.277"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M310.04 272.777H335.285"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M399.076 280.027H390.328C389.711 280.027 389.212 280.527 389.212 281.143V289.891C389.212 290.507 389.711 291.007 390.328 291.007H399.076C399.692 291.007 400.191 290.507 400.191 289.891V281.143C400.191 280.527 399.692 280.027 399.076 280.027Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M395.988 284.976L394.434 283.645H393.421L394.236 284.976H395.988Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M398.394 284.98H392.216L391.351 283.844H390.344L391.34 286.309H394.068L393.279 288.152H394.55L395.987 286.309H398.394C398.762 286.309 399.06 286.011 399.06 285.643C399.06 285.275 398.762 284.977 398.394 284.977V284.98Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M324.551 313.977H315.803C315.187 313.977 314.688 314.476 314.688 315.092V323.84C314.688 324.457 315.187 324.956 315.803 324.956H324.551C325.168 324.956 325.667 324.457 325.667 323.84V315.092C325.667 314.476 325.168 313.977 324.551 313.977Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M317.851 320.346C317.851 320.989 318.111 321.57 318.531 321.991C318.952 322.411 319.533 322.671 320.176 322.671C320.818 322.671 321.399 322.411 321.82 321.991C322.241 321.57 322.501 320.989 322.501 320.346C322.501 320.086 322.419 319.777 322.299 319.47C322.153 319.093 321.951 318.722 321.782 318.474C321.759 318.436 321.715 318.407 321.665 318.404C321.583 318.398 321.51 318.459 321.505 318.544C321.496 318.661 321.484 318.783 321.464 318.9C321.446 319.014 321.42 319.125 321.382 319.216C321.35 319.298 321.291 319.347 321.227 319.368C321.192 319.379 321.154 319.382 321.116 319.373C321.081 319.368 321.049 319.35 321.02 319.327C320.97 319.28 320.935 319.201 320.938 319.084C320.985 317.215 320.027 316.371 319.959 316.315C319.933 316.292 319.895 316.277 319.857 316.277C319.775 316.277 319.708 316.347 319.711 316.429C319.732 317.332 319.253 317.875 318.785 318.41C318.309 318.95 317.845 319.479 317.845 320.349L317.851 320.346Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M324.551 280.027H315.803C315.187 280.027 314.688 280.527 314.688 281.143V289.891C314.688 290.507 315.187 291.007 315.803 291.007H324.551C325.168 291.007 325.667 290.507 325.667 289.891V281.143C325.667 280.527 325.168 280.027 324.551 280.027Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M322.936 284.255H321.14V283.379H316.583V287.576H317.678H318.855H320.766H321.14H323.771V285.832L322.936 284.255Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M321.867 287.57H321.14"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M316.583 285.816H321.14"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M321.867 284.254V285.814H323.772"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M318.266 288.172C318.592 288.172 318.856 287.908 318.856 287.582C318.856 287.256 318.592 286.992 318.266 286.992C317.94 286.992 317.676 287.256 317.676 287.582C317.676 287.908 317.94 288.172 318.266 288.172Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M322.457 288.172C322.783 288.172 323.047 287.908 323.047 287.582C323.047 287.256 322.783 286.992 322.457 286.992C322.131 286.992 321.867 287.256 321.867 287.582C321.867 287.908 322.131 288.172 322.457 288.172Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M321.14 284.254V287.575"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M361.985 280.027H353.237C352.621 280.027 352.121 280.527 352.121 281.143V289.891C352.121 290.507 352.621 291.007 353.237 291.007H361.985C362.601 291.007 363.101 290.507 363.101 289.891V281.143C363.101 280.527 362.601 280.027 361.985 280.027Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M360.798 284.477H359.3V285.572H360.798V284.477Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M359.3 284.477H357.802V285.572H359.3V284.477Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M359.3 283.387H357.802V284.482H359.3V283.387Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M355.717 283.434H354.779V285.583H355.717V283.434Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M356.733 284.707H355.717V285.569H356.733V284.707Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M354.779 284.25H355.717"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M355.248 282.48V283.424"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M360.643 287.496C360.503 287.593 360.38 287.698 360.103 287.698C359.603 287.698 359.603 287.35 359.104 287.35C358.604 287.35 358.604 287.698 358.105 287.698C357.605 287.698 357.605 287.35 357.106 287.35C356.606 287.35 356.606 287.698 356.107 287.698C355.607 287.698 355.607 287.35 355.108 287.35C354.608 287.35 354.608 287.698 354.109 287.698C354.062 287.698 354.021 287.695 353.983 287.689V285.574H361.613L360.643 287.496Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M353.112 287.34C353.612 287.34 353.612 287.687 354.111 287.687C354.611 287.687 354.611 287.34 355.11 287.34C355.61 287.34 355.61 287.687 356.109 287.687C356.609 287.687 356.609 287.34 357.108 287.34C357.608 287.34 357.608 287.687 358.107 287.687C358.606 287.687 358.606 287.34 359.106 287.34C359.605 287.34 359.605 287.687 360.105 287.687C360.604 287.687 360.604 287.34 361.107 287.34C361.609 287.34 361.606 287.687 362.109 287.687"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M361.985 297.004H353.237C352.621 297.004 352.121 297.503 352.121 298.12V306.868C352.121 307.484 352.621 307.983 353.237 307.983H361.985C362.601 307.983 363.101 307.484 363.101 306.868V298.12C363.101 297.503 362.601 297.004 361.985 297.004Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M357.667 303.066C357.1 303.066 356.642 303.525 356.642 304.092C356.642 304.658 357.1 305.117 357.667 305.117H360.874C361.441 305.117 361.899 304.658 361.899 304.092C361.899 303.525 361.441 303.066 360.874 303.066H357.667Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M360.873 305.117C361.439 305.117 361.898 304.658 361.898 304.092C361.898 303.525 361.439 303.066 360.873 303.066C360.307 303.066 359.848 303.525 359.848 304.092C359.848 304.658 360.307 305.117 360.873 305.117Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M356.641 301.273C356.075 301.273 355.616 301.732 355.616 302.299C355.616 302.865 356.075 303.324 356.641 303.324H359.849C360.415 303.324 360.874 302.865 360.874 302.299C360.874 301.732 360.415 301.273 359.849 301.273H356.641Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M359.847 303.324C360.414 303.324 360.873 302.865 360.873 302.299C360.873 301.732 360.414 301.273 359.847 301.273C359.281 301.273 358.822 301.732 358.822 302.299C358.822 302.865 359.281 303.324 359.847 303.324Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M355.613 303.066C355.046 303.066 354.588 303.525 354.588 304.092C354.588 304.658 355.046 305.117 355.613 305.117H358.82C359.387 305.117 359.845 304.658 359.845 304.092C359.845 303.525 359.387 303.066 358.82 303.066H355.613Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M358.819 305.117C359.385 305.117 359.844 304.658 359.844 304.092C359.844 303.525 359.385 303.066 358.819 303.066C358.253 303.066 357.794 303.525 357.794 304.092C357.794 304.658 358.253 305.117 358.819 305.117Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M359.393 302.611C359.334 302.523 359.299 302.418 359.299 302.303C359.299 302.189 359.334 302.084 359.393 301.996"
        fill="white"
      />
      <path
        d="M359.393 302.611C359.334 302.523 359.299 302.418 359.299 302.303C359.299 302.189 359.334 302.084 359.393 301.996"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M360.157 301.859C360.303 301.959 360.399 302.125 360.399 302.315C360.399 302.581 360.209 302.803 359.958 302.855"
        fill="white"
      />
      <path
        d="M360.157 301.859C360.303 301.959 360.399 302.125 360.399 302.315C360.399 302.581 360.209 302.803 359.958 302.855"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M361.449 304.098C361.449 304.414 361.191 304.671 360.875 304.671L361.449 304.098Z"
        fill="white"
      />
      <path
        d="M361.449 304.098C361.449 304.414 361.191 304.671 360.875 304.671"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M360.373 304.362C360.329 304.28 360.303 304.186 360.303 304.084C360.303 303.769 360.56 303.512 360.875 303.512C360.98 303.512 361.077 303.541 361.161 303.588"
        fill="white"
      />
      <path
        d="M360.373 304.362C360.329 304.28 360.303 304.186 360.303 304.084C360.303 303.769 360.56 303.512 360.875 303.512C360.98 303.512 361.077 303.541 361.161 303.588"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M359.366 303.922C359.383 303.977 359.395 304.036 359.395 304.097C359.395 304.413 359.141 304.667 358.825 304.667C358.726 304.667 358.633 304.64 358.551 304.597"
        fill="white"
      />
      <path
        d="M359.366 303.922C359.383 303.977 359.395 304.036 359.395 304.097C359.395 304.413 359.141 304.667 358.825 304.667C358.726 304.667 358.633 304.64 358.551 304.597"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M358.254 304.081C358.254 303.886 358.353 303.71 358.505 303.608C358.596 303.547 358.707 303.512 358.823 303.512C358.894 303.512 358.958 303.523 359.019 303.547"
        fill="white"
      />
      <path
        d="M358.254 304.081C358.254 303.886 358.353 303.71 358.505 303.608C358.596 303.547 358.707 303.512 358.823 303.512C358.894 303.512 358.958 303.523 359.019 303.547"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M354.762 304.609H356.412"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M355.589 303.551H357.041"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M355.833 301.742H357.445"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M358.839 302.109H357.703"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M353.317 305.125H357.182"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M356.822 300.215H353.711V305.128H356.822V300.215Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M353.354 300.215H357.181"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M353.354 304.062H357.181"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M353.354 301.281H356.824"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M358.35 303.063V302.52H355.75V303.063H356.504C356.655 303.063 356.778 303.186 356.778 303.337V304.301C356.778 304.453 356.655 304.576 356.504 304.576H355.75V305.119H358.35V304.576H357.596C357.444 304.576 357.321 304.453 357.321 304.301V303.337C357.321 303.186 357.444 303.063 357.596 303.063H358.35Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M361.985 313.977H353.237C352.621 313.977 352.121 314.476 352.121 315.092V323.84C352.121 324.457 352.621 324.956 353.237 324.956H361.985C362.601 324.956 363.101 324.457 363.101 323.84V315.092C363.101 314.476 362.601 313.977 361.985 313.977Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M357.855 316.529C357.742 316.339 357.467 316.339 357.356 316.529C356.81 317.452 355.568 319.643 355.568 320.51C355.563 321.626 356.474 322.54 357.604 322.54C358.735 322.54 359.649 321.626 359.649 320.502C359.649 319.634 358.402 317.449 357.852 316.526L357.855 316.529Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M399.076 313.977H390.328C389.711 313.977 389.212 314.476 389.212 315.092V323.84C389.212 324.457 389.711 324.956 390.328 324.956H399.076C399.692 324.956 400.191 324.457 400.191 323.84V315.092C400.191 314.476 399.692 313.977 399.076 313.977Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M394.224 316.387L392.352 319.752H393.914L393.018 322.672L397.048 318.767H395.261L396.923 316.387H394.224Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M324.552 297.004H315.804C315.188 297.004 314.688 297.503 314.688 298.12V306.868C314.688 307.484 315.188 307.983 315.804 307.983H324.552C325.169 307.983 325.668 307.484 325.668 306.868V298.12C325.668 297.503 325.169 297.004 324.552 297.004Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M317.331 306.183H322.621V298.699H319.656L317.331 301.024V306.183Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M319.656 298.699V301.024H317.331L318.645 299.71L319.656 298.699Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M321.733 304.324C321.47 304.897 320.945 305.288 320.34 305.288C319.47 305.288 318.763 304.479 318.763 303.48C318.763 302.481 319.47 301.672 320.34 301.672C320.945 301.672 321.47 302.063 321.733 302.636"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M318.176 303.941H320.378"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M318.176 303.027H320.378"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M399.076 297.004H390.328C389.711 297.004 389.212 297.503 389.212 298.12V306.868C389.212 307.484 389.711 307.983 390.328 307.983H399.076C399.692 307.983 400.191 307.484 400.191 306.868V298.12C400.191 297.503 399.692 297.004 399.076 297.004Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M396.352 300.137H391.74V304.749H396.352V300.137Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M397.657 300.137H393.045V304.749H397.657V300.137Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M395.932 300.137H394.772V301.758H395.932V300.137Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M404.239 318.021H402.788V318.883C402.849 318.802 402.938 318.734 403.056 318.679C403.178 318.624 403.306 318.597 403.442 318.597C403.684 318.597 403.881 318.649 404.031 318.753C404.184 318.857 404.292 318.988 404.356 319.147C404.422 319.306 404.455 319.473 404.455 319.649C404.455 319.863 404.414 320.054 404.33 320.221C404.249 320.386 404.126 320.516 403.962 320.611C403.8 320.706 403.601 320.754 403.364 320.754C403.049 320.754 402.797 320.676 402.606 320.52C402.415 320.364 402.301 320.158 402.264 319.901H402.745C402.776 320.036 402.847 320.145 402.957 320.226C403.067 320.303 403.204 320.342 403.368 320.342C403.573 320.342 403.726 320.28 403.827 320.156C403.931 320.032 403.983 319.867 403.983 319.662C403.983 319.455 403.931 319.296 403.827 319.186C403.723 319.073 403.57 319.017 403.368 319.017C403.227 319.017 403.107 319.053 403.009 319.125C402.914 319.195 402.844 319.29 402.801 319.411H402.333V317.588H404.239V318.021ZM405.234 320.784C405.144 320.784 405.069 320.754 405.008 320.693C404.948 320.633 404.917 320.558 404.917 320.468C404.917 320.379 404.948 320.303 405.008 320.243C405.069 320.182 405.144 320.152 405.234 320.152C405.32 320.152 405.394 320.182 405.454 320.243C405.515 320.303 405.545 320.379 405.545 320.468C405.545 320.558 405.515 320.633 405.454 320.693C405.394 320.754 405.32 320.784 405.234 320.784ZM408.05 318.021H406.599V318.883C406.659 318.802 406.749 318.734 406.867 318.679C406.989 318.624 407.117 318.597 407.253 318.597C407.495 318.597 407.692 318.649 407.842 318.753C407.995 318.857 408.103 318.988 408.167 319.147C408.233 319.306 408.266 319.473 408.266 319.649C408.266 319.863 408.224 320.054 408.141 320.221C408.06 320.386 407.937 320.516 407.773 320.611C407.611 320.706 407.412 320.754 407.175 320.754C406.86 320.754 406.607 320.676 406.417 320.52C406.226 320.364 406.112 320.158 406.075 319.901H406.556C406.587 320.036 406.658 320.145 406.768 320.226C406.877 320.303 407.015 320.342 407.179 320.342C407.384 320.342 407.537 320.28 407.638 320.156C407.742 320.032 407.794 319.867 407.794 319.662C407.794 319.455 407.742 319.296 407.638 319.186C407.534 319.073 407.381 319.017 407.179 319.017C407.038 319.017 406.918 319.053 406.82 319.125C406.724 319.195 406.655 319.29 406.612 319.411H406.144V317.588H408.05V318.021ZM410.504 320.754L409.339 319.407V320.754H408.845V317.744H409.339V319.117L410.508 317.744H411.128L409.82 319.251L411.149 320.754H410.504ZM404.447 324.61C404.369 324.46 404.261 324.347 404.122 324.272C403.983 324.194 403.823 324.155 403.641 324.155C403.442 324.155 403.264 324.2 403.108 324.289C402.953 324.379 402.83 324.506 402.74 324.671C402.654 324.835 402.61 325.026 402.61 325.242C402.61 325.459 402.654 325.651 402.74 325.818C402.83 325.983 402.953 326.11 403.108 326.2C403.264 326.289 403.442 326.334 403.641 326.334C403.91 326.334 404.128 326.259 404.295 326.109C404.463 325.958 404.565 325.755 404.603 325.498H403.472V325.104H405.131V325.489C405.099 325.723 405.016 325.938 404.88 326.135C404.747 326.331 404.572 326.488 404.356 326.607C404.142 326.722 403.904 326.78 403.641 326.78C403.358 326.78 403.1 326.715 402.866 326.585C402.632 326.452 402.446 326.269 402.307 326.035C402.171 325.801 402.104 325.537 402.104 325.242C402.104 324.948 402.171 324.684 402.307 324.45C402.446 324.216 402.632 324.034 402.866 323.904C403.103 323.771 403.361 323.705 403.641 323.705C403.962 323.705 404.246 323.784 404.494 323.943C404.746 324.099 404.928 324.321 405.04 324.61H404.447Z"
        fill="#0E4D0D"
      />
      <path
        d="M402.104 324.067C402.104 323.772 402.171 323.508 402.307 323.274C402.446 323.04 402.632 322.858 402.866 322.728C403.103 322.595 403.361 322.529 403.641 322.529C403.962 322.529 404.246 322.608 404.494 322.767C404.746 322.923 404.928 323.145 405.04 323.434H404.447C404.369 323.275 404.261 323.157 404.122 323.079C403.983 323.001 403.823 322.962 403.641 322.962C403.442 322.962 403.264 323.007 403.108 323.096C402.953 323.186 402.83 323.314 402.74 323.482C402.654 323.649 402.61 323.844 402.61 324.067C402.61 324.289 402.654 324.484 402.74 324.651C402.83 324.819 402.953 324.949 403.108 325.041C403.264 325.131 403.442 325.175 403.641 325.175C403.823 325.175 403.983 325.136 404.122 325.058C404.261 324.98 404.369 324.862 404.447 324.703H405.04C404.928 324.992 404.746 325.214 404.494 325.37C404.246 325.526 403.962 325.604 403.641 325.604C403.358 325.604 403.1 325.539 402.866 325.409C402.632 325.276 402.446 325.093 402.307 324.859C402.171 324.625 402.104 324.361 402.104 324.067ZM406.991 325.608C406.711 325.608 406.453 325.543 406.216 325.414C405.982 325.281 405.796 325.097 405.657 324.863C405.521 324.627 405.453 324.361 405.453 324.067C405.453 323.772 405.521 323.508 405.657 323.274C405.796 323.04 405.982 322.858 406.216 322.728C406.453 322.595 406.711 322.529 406.991 322.529C407.274 322.529 407.532 322.595 407.766 322.728C408.003 322.858 408.189 323.04 408.325 323.274C408.461 323.508 408.529 323.772 408.529 324.067C408.529 324.361 408.461 324.627 408.325 324.863C408.189 325.097 408.003 325.281 407.766 325.414C407.532 325.543 407.274 325.608 406.991 325.608ZM406.991 325.18C407.19 325.18 407.368 325.135 407.524 325.045C407.68 324.953 407.801 324.823 407.888 324.656C407.977 324.485 408.022 324.289 408.022 324.067C408.022 323.844 407.977 323.649 407.888 323.482C407.801 323.314 407.68 323.186 407.524 323.096C407.368 323.007 407.19 322.962 406.991 322.962C406.792 322.962 406.614 323.007 406.458 323.096C406.302 323.186 406.18 323.314 406.09 323.482C406.004 323.649 405.96 323.844 405.96 324.067C405.96 324.289 406.004 324.485 406.09 324.656C406.18 324.823 406.302 324.953 406.458 325.045C406.614 325.135 406.792 325.18 406.991 325.18ZM402.476 330.907C402.753 330.667 402.971 330.471 403.13 330.318C403.292 330.162 403.426 330 403.533 329.833C403.64 329.665 403.693 329.498 403.693 329.33C403.693 329.157 403.651 329.021 403.568 328.923C403.487 328.825 403.358 328.776 403.182 328.776C403.012 328.776 402.879 328.831 402.784 328.94C402.691 329.047 402.642 329.192 402.636 329.374H402.16C402.169 329.044 402.267 328.793 402.454 328.62C402.645 328.444 402.886 328.356 403.178 328.356C403.492 328.356 403.738 328.442 403.914 328.616C404.093 328.789 404.183 329.02 404.183 329.309C404.183 329.517 404.129 329.717 404.022 329.911C403.918 330.101 403.793 330.273 403.645 330.426C403.501 330.576 403.316 330.751 403.091 330.95L402.896 331.123H404.269V331.535H402.164V331.175L402.476 330.907Z"
        fill="#0E4D0D"
      />
      <path
        d="M365.385 320.083C365.662 319.843 365.88 319.647 366.039 319.494C366.201 319.338 366.335 319.176 366.442 319.008C366.549 318.841 366.602 318.674 366.602 318.506C366.602 318.333 366.56 318.197 366.477 318.099C366.396 318.001 366.267 317.952 366.091 317.952C365.921 317.952 365.788 318.007 365.693 318.116C365.6 318.223 365.551 318.367 365.546 318.549H365.069C365.078 318.22 365.176 317.969 365.364 317.796C365.554 317.62 365.795 317.532 366.087 317.532C366.402 317.532 366.647 317.618 366.823 317.791C367.002 317.965 367.092 318.196 367.092 318.484C367.092 318.692 367.038 318.893 366.931 319.086C366.828 319.277 366.702 319.449 366.555 319.602C366.41 319.752 366.226 319.927 366 320.126L365.805 320.299H367.178V320.711H365.073V320.351L365.385 320.083ZM367.876 320.784C367.787 320.784 367.712 320.754 367.651 320.693C367.59 320.633 367.56 320.558 367.56 320.468C367.56 320.379 367.59 320.303 367.651 320.243C367.712 320.182 367.787 320.152 367.876 320.152C367.963 320.152 368.037 320.182 368.097 320.243C368.158 320.303 368.188 320.379 368.188 320.468C368.188 320.558 368.158 320.633 368.097 320.693C368.037 320.754 367.963 320.784 367.876 320.784ZM370.658 317.978L369.454 320.754H368.956L370.173 318.03H368.57V317.61H370.658V317.978ZM372.804 320.754L371.639 319.407V320.754H371.145V317.744H371.639V319.117L372.809 317.744H373.428L372.12 319.251L373.45 320.754H372.804ZM367.356 324.61C367.278 324.46 367.17 324.347 367.031 324.272C366.893 324.194 366.732 324.155 366.55 324.155C366.351 324.155 366.174 324.2 366.018 324.289C365.862 324.379 365.739 324.506 365.649 324.671C365.563 324.835 365.52 325.026 365.52 325.242C365.52 325.459 365.563 325.651 365.649 325.818C365.739 325.983 365.862 326.11 366.018 326.2C366.174 326.289 366.351 326.334 366.55 326.334C366.819 326.334 367.037 326.259 367.204 326.109C367.372 325.958 367.474 325.755 367.512 325.498H366.381V325.104H368.04V325.489C368.008 325.723 367.925 325.938 367.789 326.135C367.656 326.331 367.482 326.488 367.265 326.607C367.051 326.722 366.813 326.78 366.55 326.78C366.267 326.78 366.009 326.715 365.775 326.585C365.541 326.452 365.355 326.269 365.216 326.035C365.081 325.801 365.013 325.537 365.013 325.242C365.013 324.948 365.081 324.684 365.216 324.45C365.355 324.216 365.541 324.034 365.775 323.904C366.012 323.771 366.27 323.705 366.55 323.705C366.871 323.705 367.155 323.784 367.404 323.943C367.655 324.099 367.837 324.321 367.949 324.61H367.356Z"
        fill="#0E4D0D"
      />
      <path
        d="M365.013 324.067C365.013 323.772 365.081 323.508 365.216 323.274C365.355 323.04 365.541 322.858 365.775 322.728C366.012 322.595 366.27 322.529 366.55 322.529C366.871 322.529 367.155 322.608 367.404 322.767C367.655 322.923 367.837 323.145 367.949 323.434H367.356C367.278 323.275 367.17 323.157 367.031 323.079C366.893 323.001 366.732 322.962 366.55 322.962C366.351 322.962 366.174 323.007 366.018 323.096C365.862 323.186 365.739 323.314 365.649 323.482C365.563 323.649 365.52 323.844 365.52 324.067C365.52 324.289 365.563 324.484 365.649 324.651C365.739 324.819 365.862 324.949 366.018 325.041C366.174 325.131 366.351 325.175 366.55 325.175C366.732 325.175 366.893 325.136 367.031 325.058C367.17 324.98 367.278 324.862 367.356 324.703H367.949C367.837 324.992 367.655 325.214 367.404 325.37C367.155 325.526 366.871 325.604 366.55 325.604C366.267 325.604 366.009 325.539 365.775 325.409C365.541 325.276 365.355 325.093 365.216 324.859C365.081 324.625 365.013 324.361 365.013 324.067ZM369.9 325.608C369.62 325.608 369.362 325.543 369.125 325.414C368.891 325.281 368.705 325.097 368.566 324.863C368.431 324.627 368.363 324.361 368.363 324.067C368.363 323.772 368.431 323.508 368.566 323.274C368.705 323.04 368.891 322.858 369.125 322.728C369.362 322.595 369.62 322.529 369.9 322.529C370.183 322.529 370.442 322.595 370.675 322.728C370.912 322.858 371.098 323.04 371.234 323.274C371.37 323.508 371.438 323.772 371.438 324.067C371.438 324.361 371.37 324.627 371.234 324.863C371.098 325.097 370.912 325.281 370.675 325.414C370.442 325.543 370.183 325.608 369.9 325.608ZM369.9 325.18C370.099 325.18 370.277 325.135 370.433 325.045C370.589 324.953 370.71 324.823 370.797 324.656C370.886 324.485 370.931 324.289 370.931 324.067C370.931 323.844 370.886 323.649 370.797 323.482C370.71 323.314 370.589 323.186 370.433 323.096C370.277 323.007 370.099 322.962 369.9 322.962C369.701 322.962 369.523 323.007 369.367 323.096C369.212 323.186 369.089 323.314 368.999 323.482C368.913 323.649 368.869 323.844 368.869 324.067C368.869 324.289 368.913 324.485 368.999 324.656C369.089 324.823 369.212 324.953 369.367 325.045C369.523 325.135 369.701 325.18 369.9 325.18ZM365.385 330.907C365.662 330.667 365.88 330.471 366.039 330.318C366.201 330.162 366.335 330 366.442 329.833C366.549 329.665 366.602 329.498 366.602 329.33C366.602 329.157 366.56 329.021 366.477 328.923C366.396 328.825 366.267 328.776 366.091 328.776C365.921 328.776 365.788 328.831 365.693 328.94C365.6 329.047 365.551 329.192 365.546 329.374H365.069C365.078 329.044 365.176 328.793 365.364 328.62C365.554 328.444 365.795 328.356 366.087 328.356C366.402 328.356 366.647 328.442 366.823 328.616C367.002 328.789 367.092 329.02 367.092 329.309C367.092 329.517 367.038 329.717 366.931 329.911C366.828 330.101 366.702 330.273 366.555 330.426C366.41 330.576 366.226 330.751 366 330.95L365.805 331.123H367.178V331.535H365.073V331.175L365.385 330.907Z"
        fill="#0E4D0D"
      />
      <path
        d="M327.955 320.083C328.232 319.843 328.45 319.647 328.609 319.494C328.77 319.338 328.905 319.176 329.011 319.008C329.118 318.841 329.172 318.674 329.172 318.506C329.172 318.333 329.13 318.197 329.046 318.099C328.965 318.001 328.837 317.952 328.661 317.952C328.49 317.952 328.357 318.007 328.262 318.116C328.17 318.223 328.121 318.367 328.115 318.549H327.638C327.647 318.22 327.745 317.969 327.933 317.796C328.124 317.62 328.365 317.532 328.656 317.532C328.971 317.532 329.216 317.618 329.393 317.791C329.572 317.965 329.661 318.196 329.661 318.484C329.661 318.692 329.608 318.893 329.501 319.086C329.397 319.277 329.271 319.449 329.124 319.602C328.98 319.752 328.795 319.927 328.57 320.126L328.375 320.299H329.748V320.711H327.643V320.351L327.955 320.083ZM330.173 318.376C330.19 318.108 330.293 317.898 330.48 317.748C330.671 317.598 330.913 317.523 331.208 317.523C331.41 317.523 331.585 317.559 331.732 317.631C331.879 317.703 331.99 317.802 332.065 317.926C332.141 318.05 332.178 318.19 332.178 318.346C332.178 318.525 332.13 318.678 332.035 318.805C331.94 318.932 331.826 319.017 331.693 319.06V319.078C331.863 319.13 331.996 319.225 332.091 319.364C332.187 319.499 332.234 319.674 332.234 319.888C332.234 320.058 332.195 320.21 332.117 320.342C332.04 320.475 331.924 320.581 331.771 320.659C331.618 320.734 331.435 320.771 331.221 320.771C330.909 320.771 330.652 320.692 330.45 320.533C330.251 320.371 330.144 320.14 330.129 319.84H330.606C330.617 319.993 330.677 320.119 330.783 320.217C330.89 320.312 331.035 320.36 331.217 320.36C331.393 320.36 331.528 320.312 331.624 320.217C331.719 320.119 331.767 319.993 331.767 319.84C331.767 319.638 331.702 319.495 331.572 319.411C331.445 319.325 331.248 319.281 330.983 319.281H330.87V318.874H330.987C331.221 318.871 331.398 318.832 331.52 318.757C331.644 318.682 331.706 318.564 331.706 318.402C331.706 318.264 331.661 318.154 331.572 318.073C331.482 317.989 331.355 317.947 331.191 317.947C331.029 317.947 330.903 317.989 330.814 318.073C330.724 318.154 330.671 318.255 330.654 318.376H330.173ZM333.017 320.784C332.928 320.784 332.853 320.754 332.792 320.693C332.731 320.633 332.701 320.558 332.701 320.468C332.701 320.379 332.731 320.303 332.792 320.243C332.853 320.182 332.928 320.152 333.017 320.152C333.104 320.152 333.178 320.182 333.238 320.243C333.299 320.303 333.329 320.379 333.329 320.468C333.329 320.558 333.299 320.633 333.238 320.693C333.178 320.754 333.104 320.784 333.017 320.784ZM328.297 325.896C328.326 326.041 328.388 326.15 328.483 326.226C328.578 326.301 328.707 326.338 328.868 326.338C329.073 326.338 329.224 326.257 329.319 326.096C329.414 325.934 329.462 325.658 329.462 325.268C329.393 325.367 329.294 325.443 329.167 325.498C329.043 325.55 328.907 325.576 328.76 325.576C328.573 325.576 328.402 325.538 328.249 325.463C328.096 325.385 327.975 325.271 327.885 325.121C327.799 324.968 327.755 324.783 327.755 324.567C327.755 324.249 327.848 323.996 328.033 323.809C328.22 323.618 328.477 323.523 328.804 323.523C329.196 323.523 329.475 323.654 329.639 323.917C329.807 324.177 329.891 324.577 329.891 325.117C329.891 325.489 329.859 325.794 329.795 326.031C329.735 326.267 329.628 326.446 329.475 326.568C329.322 326.689 329.11 326.75 328.838 326.75C328.529 326.75 328.291 326.669 328.124 326.507C327.956 326.345 327.862 326.142 327.842 325.896H328.297ZM328.847 325.16C329.02 325.16 329.156 325.107 329.254 325C329.355 324.89 329.406 324.746 329.406 324.567C329.406 324.367 329.352 324.213 329.245 324.103C329.141 323.991 328.998 323.934 328.816 323.934C328.635 323.934 328.49 323.992 328.383 324.108C328.279 324.22 328.227 324.369 328.227 324.554C328.227 324.73 328.278 324.876 328.379 324.991C328.483 325.104 328.639 325.16 328.847 325.16ZM332.155 326.754L330.99 325.407V326.754H330.496V323.744H330.99V325.117L332.159 323.744H332.778L331.47 325.251L332.8 326.754H332.155ZM335.415 324.61C335.337 324.46 335.229 324.347 335.09 324.272C334.952 324.194 334.792 324.155 334.61 324.155C334.41 324.155 334.233 324.2 334.077 324.289C333.921 324.379 333.798 324.506 333.709 324.671C333.622 324.835 333.579 325.026 333.579 325.242C333.579 325.459 333.622 325.651 333.709 325.818C333.798 325.983 333.921 326.11 334.077 326.2C334.233 326.289 334.41 326.334 334.61 326.334C334.878 326.334 335.096 326.259 335.264 326.109C335.431 325.958 335.534 325.755 335.571 325.498H334.441V325.104H336.1V325.489C336.068 325.723 335.984 325.938 335.848 326.135C335.716 326.331 335.541 326.488 335.324 326.607C335.111 326.722 334.872 326.78 334.61 326.78C334.327 326.78 334.068 326.715 333.834 326.585C333.601 326.452 333.414 326.269 333.276 326.035C333.14 325.801 333.072 325.537 333.072 325.242C333.072 324.948 333.14 324.684 333.276 324.45C333.414 324.216 333.601 324.034 333.834 323.904C334.071 323.771 334.33 323.705 334.61 323.705C334.93 323.705 335.215 323.784 335.463 323.943C335.714 324.099 335.896 324.321 336.009 324.61H335.415Z"
        fill="#0E4D0D"
      />
      <path
        d="M327.582 324.067C327.582 323.772 327.65 323.508 327.786 323.274C327.924 323.04 328.111 322.858 328.344 322.728C328.581 322.595 328.84 322.529 329.12 322.529C329.44 322.529 329.725 322.608 329.973 322.767C330.224 322.923 330.406 323.145 330.519 323.434H329.925C329.847 323.275 329.739 323.157 329.6 323.079C329.462 323.001 329.302 322.962 329.12 322.962C328.92 322.962 328.743 323.007 328.587 323.096C328.431 323.186 328.308 323.314 328.219 323.482C328.132 323.649 328.089 323.844 328.089 324.067C328.089 324.289 328.132 324.484 328.219 324.651C328.308 324.819 328.431 324.949 328.587 325.041C328.743 325.131 328.92 325.175 329.12 325.175C329.302 325.175 329.462 325.136 329.6 325.058C329.739 324.98 329.847 324.862 329.925 324.703H330.519C330.406 324.992 330.224 325.214 329.973 325.37C329.725 325.526 329.44 325.604 329.12 325.604C328.837 325.604 328.578 325.539 328.344 325.409C328.111 325.276 327.924 325.093 327.786 324.859C327.65 324.625 327.582 324.361 327.582 324.067ZM332.47 325.608C332.189 325.608 331.931 325.543 331.694 325.414C331.46 325.281 331.274 325.097 331.136 324.863C331 324.627 330.932 324.361 330.932 324.067C330.932 323.772 331 323.508 331.136 323.274C331.274 323.04 331.46 322.858 331.694 322.728C331.931 322.595 332.189 322.529 332.47 322.529C332.753 322.529 333.011 322.595 333.245 322.728C333.482 322.858 333.668 323.04 333.804 323.274C333.939 323.508 334.007 323.772 334.007 324.067C334.007 324.361 333.939 324.627 333.804 324.863C333.668 325.097 333.482 325.281 333.245 325.414C333.011 325.543 332.753 325.608 332.47 325.608ZM332.47 325.18C332.669 325.18 332.846 325.135 333.002 325.045C333.158 324.953 333.279 324.823 333.366 324.656C333.456 324.485 333.5 324.289 333.5 324.067C333.5 323.844 333.456 323.649 333.366 323.482C333.279 323.314 333.158 323.186 333.002 323.096C332.846 323.007 332.669 322.962 332.47 322.962C332.27 322.962 332.093 323.007 331.937 323.096C331.781 323.186 331.658 323.314 331.569 323.482C331.482 323.649 331.439 323.844 331.439 324.067C331.439 324.289 331.482 324.485 331.569 324.656C331.658 324.823 331.781 324.953 331.937 325.045C332.093 325.135 332.27 325.18 332.47 325.18ZM327.955 330.907C328.232 330.667 328.45 330.471 328.609 330.318C328.77 330.162 328.905 330 329.011 329.833C329.118 329.665 329.172 329.498 329.172 329.33C329.172 329.157 329.13 329.021 329.046 328.923C328.965 328.825 328.837 328.776 328.661 328.776C328.49 328.776 328.357 328.831 328.262 328.94C328.17 329.047 328.121 329.192 328.115 329.374H327.638C327.647 329.044 327.745 328.793 327.933 328.62C328.124 328.444 328.365 328.356 328.656 328.356C328.971 328.356 329.216 328.442 329.393 328.616C329.572 328.789 329.661 329.02 329.661 329.309C329.661 329.517 329.608 329.717 329.501 329.911C329.397 330.101 329.271 330.273 329.124 330.426C328.98 330.576 328.795 330.751 328.57 330.95L328.375 331.123H329.748V331.535H327.643V331.175L327.955 330.907Z"
        fill="#0E4D0D"
      />
      <path
        d="M327.621 303.154V302.782L329.076 300.694H329.674V302.725H330.077V303.154H329.674V303.812H329.189V303.154H327.621ZM329.211 301.196L328.188 302.725H329.211V301.196ZM330.75 303.843C330.661 303.843 330.586 303.812 330.525 303.752C330.464 303.691 330.434 303.616 330.434 303.527C330.434 303.437 330.464 303.362 330.525 303.301C330.586 303.241 330.661 303.21 330.75 303.21C330.837 303.21 330.91 303.241 330.971 303.301C331.032 303.362 331.062 303.437 331.062 303.527C331.062 303.616 331.032 303.691 330.971 303.752C330.91 303.812 330.837 303.843 330.75 303.843ZM331.466 301.106V300.655H332.367V303.812H331.869V301.106H331.466ZM334.769 303.812L333.604 302.466V303.812H333.11V300.802H333.604V302.175L334.773 300.802H335.392L334.084 302.31L335.414 303.812H334.769ZM329.925 307.669C329.847 307.518 329.739 307.406 329.6 307.331C329.462 307.253 329.302 307.214 329.12 307.214C328.92 307.214 328.743 307.259 328.587 307.348C328.431 307.438 328.308 307.565 328.219 307.729C328.132 307.894 328.089 308.084 328.089 308.301C328.089 308.517 328.132 308.71 328.219 308.877C328.308 309.042 328.431 309.169 328.587 309.258C328.743 309.348 328.92 309.392 329.12 309.392C329.388 309.392 329.606 309.317 329.774 309.167C329.941 309.017 330.044 308.813 330.081 308.556H328.951V308.162H330.61V308.548C330.578 308.782 330.494 308.997 330.358 309.193C330.226 309.389 330.051 309.547 329.834 309.665C329.621 309.781 329.382 309.838 329.12 309.838C328.837 309.838 328.578 309.774 328.344 309.644C328.111 309.511 327.924 309.327 327.786 309.094C327.65 308.86 327.582 308.595 327.582 308.301C327.582 308.006 327.65 307.742 327.786 307.508C327.924 307.274 328.111 307.093 328.344 306.963C328.581 306.83 328.84 306.763 329.12 306.763C329.44 306.763 329.725 306.843 329.973 307.002C330.224 307.158 330.406 307.38 330.519 307.669H329.925Z"
        fill="#0E4D0D"
      />
      <path
        d="M327.582 307.125C327.582 306.831 327.65 306.566 327.786 306.333C327.924 306.099 328.111 305.917 328.344 305.787C328.581 305.654 328.84 305.588 329.12 305.588C329.44 305.588 329.725 305.667 329.973 305.826C330.224 305.982 330.406 306.204 330.519 306.493H329.925C329.847 306.334 329.739 306.216 329.6 306.138C329.462 306.06 329.302 306.021 329.12 306.021C328.92 306.021 328.743 306.065 328.587 306.155C328.431 306.244 328.308 306.373 328.219 306.54C328.132 306.708 328.089 306.903 328.089 307.125C328.089 307.347 328.132 307.542 328.219 307.71C328.308 307.877 328.431 308.007 328.587 308.1C328.743 308.189 328.92 308.234 329.12 308.234C329.302 308.234 329.462 308.195 329.6 308.117C329.739 308.039 329.847 307.921 329.925 307.762H330.519C330.406 308.051 330.224 308.273 329.973 308.429C329.725 308.585 329.44 308.663 329.12 308.663C328.837 308.663 328.578 308.598 328.344 308.468C328.111 308.335 327.924 308.152 327.786 307.918C327.65 307.684 327.582 307.42 327.582 307.125ZM332.47 308.667C332.189 308.667 331.931 308.602 331.694 308.472C331.46 308.339 331.274 308.156 331.136 307.922C331 307.685 330.932 307.42 330.932 307.125C330.932 306.831 331 306.566 331.136 306.333C331.274 306.099 331.46 305.917 331.694 305.787C331.931 305.654 332.189 305.588 332.47 305.588C332.753 305.588 333.011 305.654 333.245 305.787C333.482 305.917 333.668 306.099 333.804 306.333C333.939 306.566 334.007 306.831 334.007 307.125C334.007 307.42 333.939 307.685 333.804 307.922C333.668 308.156 333.482 308.339 333.245 308.472C333.011 308.602 332.753 308.667 332.47 308.667ZM332.47 308.238C332.669 308.238 332.846 308.193 333.002 308.104C333.158 308.012 333.279 307.882 333.366 307.714C333.456 307.544 333.5 307.347 333.5 307.125C333.5 306.903 333.456 306.708 333.366 306.54C333.279 306.373 333.158 306.244 333.002 306.155C332.846 306.065 332.669 306.021 332.47 306.021C332.27 306.021 332.093 306.065 331.937 306.155C331.781 306.244 331.658 306.373 331.569 306.54C331.482 306.708 331.439 306.903 331.439 307.125C331.439 307.347 331.482 307.544 331.569 307.714C331.658 307.882 331.781 308.012 331.937 308.104C332.093 308.193 332.27 308.238 332.47 308.238ZM327.955 313.965C328.232 313.726 328.45 313.529 328.609 313.376C328.77 313.22 328.905 313.059 329.011 312.891C329.118 312.724 329.172 312.556 329.172 312.389C329.172 312.216 329.13 312.08 329.046 311.982C328.965 311.884 328.837 311.834 328.661 311.834C328.49 311.834 328.357 311.889 328.262 311.999C328.17 312.106 328.121 312.25 328.115 312.432H327.638C327.647 312.103 327.745 311.852 327.933 311.679C328.124 311.502 328.365 311.414 328.656 311.414C328.971 311.414 329.216 311.501 329.393 311.674C329.572 311.847 329.661 312.078 329.661 312.367C329.661 312.575 329.608 312.776 329.501 312.969C329.397 313.16 329.271 313.332 329.124 313.485C328.98 313.635 328.795 313.809 328.57 314.009L328.375 314.182H329.748V314.593H327.643V314.234L327.955 313.965Z"
        fill="#0E4D0D"
      />
      <path
        d="M365.104 301.435C365.121 301.166 365.224 300.957 365.411 300.807C365.602 300.657 365.844 300.581 366.139 300.581C366.341 300.581 366.516 300.618 366.663 300.69C366.81 300.762 366.921 300.86 366.996 300.984C367.072 301.108 367.109 301.248 367.109 301.404C367.109 301.583 367.061 301.736 366.966 301.863C366.871 301.991 366.757 302.076 366.624 302.119V302.136C366.794 302.188 366.927 302.284 367.022 302.422C367.118 302.558 367.165 302.733 367.165 302.946C367.165 303.117 367.126 303.268 367.048 303.401C366.97 303.534 366.855 303.639 366.702 303.717C366.549 303.792 366.366 303.83 366.152 303.83C365.84 303.83 365.583 303.75 365.381 303.592C365.182 303.43 365.075 303.199 365.06 302.899H365.537C365.548 303.052 365.608 303.177 365.714 303.275C365.821 303.371 365.966 303.418 366.148 303.418C366.324 303.418 366.459 303.371 366.555 303.275C366.65 303.177 366.698 303.052 366.698 302.899C366.698 302.697 366.633 302.554 366.503 302.47C366.376 302.383 366.179 302.34 365.914 302.34H365.801V301.933H365.918C366.152 301.93 366.329 301.891 366.451 301.816C366.575 301.741 366.637 301.622 366.637 301.461C366.637 301.322 366.592 301.212 366.503 301.132C366.413 301.048 366.286 301.006 366.122 301.006C365.96 301.006 365.834 301.048 365.745 301.132C365.655 301.212 365.602 301.313 365.584 301.435H365.104ZM367.948 303.843C367.859 303.843 367.784 303.812 367.723 303.752C367.662 303.691 367.632 303.616 367.632 303.527C367.632 303.437 367.662 303.362 367.723 303.301C367.784 303.241 367.859 303.21 367.948 303.21C368.035 303.21 368.108 303.241 368.169 303.301C368.23 303.362 368.26 303.437 368.26 303.527C368.26 303.616 368.23 303.691 368.169 303.752C368.108 303.812 368.035 303.843 367.948 303.843ZM370.764 301.08H369.313V301.941C369.374 301.861 369.464 301.793 369.582 301.738C369.703 301.683 369.832 301.656 369.967 301.656C370.21 301.656 370.406 301.708 370.556 301.812C370.709 301.915 370.818 302.047 370.881 302.206C370.948 302.364 370.981 302.532 370.981 302.708C370.981 302.922 370.939 303.112 370.855 303.28C370.774 303.444 370.652 303.574 370.487 303.67C370.325 303.765 370.126 303.812 369.889 303.812C369.575 303.812 369.322 303.735 369.132 303.579C368.941 303.423 368.827 303.216 368.789 302.959H369.27C369.302 303.095 369.373 303.203 369.482 303.284C369.592 303.362 369.729 303.401 369.894 303.401C370.099 303.401 370.252 303.339 370.353 303.215C370.457 303.091 370.509 302.926 370.509 302.721C370.509 302.513 370.457 302.354 370.353 302.245C370.249 302.132 370.096 302.076 369.894 302.076C369.752 302.076 369.632 302.112 369.534 302.184C369.439 302.253 369.37 302.349 369.326 302.47H368.859V300.646H370.764V301.08ZM373.219 303.812L372.054 302.466V303.812H371.56V300.802H372.054V302.175L373.223 300.802H373.842L372.534 302.31L373.864 303.812H373.219ZM367.356 307.669C367.278 307.518 367.17 307.406 367.031 307.331C366.893 307.253 366.732 307.214 366.55 307.214C366.351 307.214 366.174 307.259 366.018 307.348C365.862 307.438 365.739 307.565 365.649 307.729C365.563 307.894 365.52 308.084 365.52 308.301C365.52 308.517 365.563 308.71 365.649 308.877C365.739 309.042 365.862 309.169 366.018 309.258C366.174 309.348 366.351 309.392 366.55 309.392C366.819 309.392 367.037 309.317 367.204 309.167C367.372 309.017 367.474 308.813 367.512 308.556H366.381V308.162H368.04V308.548C368.008 308.782 367.925 308.997 367.789 309.193C367.656 309.389 367.482 309.547 367.265 309.665C367.051 309.781 366.813 309.838 366.55 309.838C366.267 309.838 366.009 309.774 365.775 309.644C365.541 309.511 365.355 309.327 365.216 309.094C365.081 308.86 365.013 308.595 365.013 308.301C365.013 308.006 365.081 307.742 365.216 307.508C365.355 307.274 365.541 307.093 365.775 306.963C366.012 306.83 366.27 306.763 366.55 306.763C366.871 306.763 367.155 306.843 367.404 307.002C367.655 307.158 367.837 307.38 367.949 307.669H367.356Z"
        fill="#0E4D0D"
      />
      <path
        d="M365.013 307.125C365.013 306.831 365.081 306.566 365.216 306.333C365.355 306.099 365.541 305.917 365.775 305.787C366.012 305.654 366.27 305.588 366.55 305.588C366.871 305.588 367.155 305.667 367.404 305.826C367.655 305.982 367.837 306.204 367.949 306.493H367.356C367.278 306.334 367.17 306.216 367.031 306.138C366.893 306.06 366.732 306.021 366.55 306.021C366.351 306.021 366.174 306.065 366.018 306.155C365.862 306.244 365.739 306.373 365.649 306.54C365.563 306.708 365.52 306.903 365.52 307.125C365.52 307.347 365.563 307.542 365.649 307.71C365.739 307.877 365.862 308.007 366.018 308.1C366.174 308.189 366.351 308.234 366.55 308.234C366.732 308.234 366.893 308.195 367.031 308.117C367.17 308.039 367.278 307.921 367.356 307.762H367.949C367.837 308.051 367.655 308.273 367.404 308.429C367.155 308.585 366.871 308.663 366.55 308.663C366.267 308.663 366.009 308.598 365.775 308.468C365.541 308.335 365.355 308.152 365.216 307.918C365.081 307.684 365.013 307.42 365.013 307.125ZM369.9 308.667C369.62 308.667 369.362 308.602 369.125 308.472C368.891 308.339 368.705 308.156 368.566 307.922C368.431 307.685 368.363 307.42 368.363 307.125C368.363 306.831 368.431 306.566 368.566 306.333C368.705 306.099 368.891 305.917 369.125 305.787C369.362 305.654 369.62 305.588 369.9 305.588C370.183 305.588 370.442 305.654 370.675 305.787C370.912 305.917 371.098 306.099 371.234 306.333C371.37 306.566 371.438 306.831 371.438 307.125C371.438 307.42 371.37 307.685 371.234 307.922C371.098 308.156 370.912 308.339 370.675 308.472C370.442 308.602 370.183 308.667 369.9 308.667ZM369.9 308.238C370.099 308.238 370.277 308.193 370.433 308.104C370.589 308.012 370.71 307.882 370.797 307.714C370.886 307.544 370.931 307.347 370.931 307.125C370.931 306.903 370.886 306.708 370.797 306.54C370.71 306.373 370.589 306.244 370.433 306.155C370.277 306.065 370.099 306.021 369.9 306.021C369.701 306.021 369.523 306.065 369.367 306.155C369.212 306.244 369.089 306.373 368.999 306.54C368.913 306.708 368.869 306.903 368.869 307.125C368.869 307.347 368.913 307.544 368.999 307.714C369.089 307.882 369.212 308.012 369.367 308.104C369.523 308.193 369.701 308.238 369.9 308.238ZM365.385 313.965C365.662 313.726 365.88 313.529 366.039 313.376C366.201 313.22 366.335 313.059 366.442 312.891C366.549 312.724 366.602 312.556 366.602 312.389C366.602 312.216 366.56 312.08 366.477 311.982C366.396 311.884 366.267 311.834 366.091 311.834C365.921 311.834 365.788 311.889 365.693 311.999C365.6 312.106 365.551 312.25 365.546 312.432H365.069C365.078 312.103 365.176 311.852 365.364 311.679C365.554 311.502 365.795 311.414 366.087 311.414C366.402 311.414 366.647 311.501 366.823 311.674C367.002 311.847 367.092 312.078 367.092 312.367C367.092 312.575 367.038 312.776 366.931 312.969C366.828 313.16 366.702 313.332 366.555 313.485C366.41 313.635 366.226 313.809 366 314.009L365.805 314.182H367.178V314.593H365.073V314.234L365.385 313.965Z"
        fill="#0E4D0D"
      />
      <path
        d="M402.138 301.106V300.655H403.039V303.812H402.541V301.106H402.138ZM403.982 303.843C403.892 303.843 403.817 303.812 403.756 303.752C403.696 303.691 403.665 303.616 403.665 303.527C403.665 303.437 403.696 303.362 403.756 303.301C403.817 303.241 403.892 303.21 403.982 303.21C404.068 303.21 404.142 303.241 404.203 303.301C404.263 303.362 404.293 303.437 404.293 303.527C404.293 303.616 404.263 303.691 404.203 303.752C404.142 303.812 404.068 303.843 403.982 303.843ZM406.46 301.387C406.428 301.254 406.37 301.155 406.287 301.088C406.203 301.022 406.086 300.989 405.936 300.989C405.708 300.989 405.537 301.077 405.425 301.253C405.312 301.426 405.253 301.715 405.247 302.119C405.322 301.992 405.432 301.894 405.576 301.825C405.721 301.755 405.877 301.721 406.044 301.721C406.235 301.721 406.402 301.762 406.547 301.846C406.694 301.927 406.808 302.045 406.889 302.201C406.972 302.357 407.014 302.543 407.014 302.76C407.014 302.962 406.974 303.143 406.893 303.301C406.815 303.46 406.698 303.586 406.542 303.678C406.386 303.768 406.199 303.812 405.979 303.812C405.682 303.812 405.448 303.748 405.278 303.618C405.11 303.485 404.992 303.299 404.922 303.059C404.856 302.819 404.823 302.52 404.823 302.162C404.823 301.106 405.195 300.577 405.94 300.577C406.229 300.577 406.456 300.655 406.62 300.811C406.788 300.967 406.886 301.159 406.915 301.387H406.46ZM405.936 302.136C405.76 302.136 405.61 302.19 405.485 302.297C405.364 302.401 405.304 302.552 405.304 302.751C405.304 302.951 405.36 303.109 405.472 303.228C405.588 303.343 405.748 303.401 405.953 303.401C406.135 303.401 406.278 303.345 406.382 303.232C406.489 303.12 406.542 302.969 406.542 302.782C406.542 302.585 406.49 302.429 406.386 302.314C406.285 302.196 406.135 302.136 405.936 302.136ZM409.265 303.812L408.1 302.466V303.812H407.606V300.802H408.1V302.175L409.269 300.802H409.888L408.58 302.31L409.91 303.812H409.265ZM404.447 307.669C404.369 307.518 404.261 307.406 404.122 307.331C403.983 307.253 403.823 307.214 403.641 307.214C403.442 307.214 403.264 307.259 403.108 307.348C402.953 307.438 402.83 307.565 402.74 307.729C402.654 307.894 402.61 308.084 402.61 308.301C402.61 308.517 402.654 308.71 402.74 308.877C402.83 309.042 402.953 309.169 403.108 309.258C403.264 309.348 403.442 309.392 403.641 309.392C403.91 309.392 404.128 309.317 404.295 309.167C404.463 309.017 404.565 308.813 404.603 308.556H403.472V308.162H405.131V308.548C405.099 308.782 405.016 308.997 404.88 309.193C404.747 309.389 404.572 309.547 404.356 309.665C404.142 309.781 403.904 309.838 403.641 309.838C403.358 309.838 403.1 309.774 402.866 309.644C402.632 309.511 402.446 309.327 402.307 309.094C402.171 308.86 402.104 308.595 402.104 308.301C402.104 308.006 402.171 307.742 402.307 307.508C402.446 307.274 402.632 307.093 402.866 306.963C403.103 306.83 403.361 306.763 403.641 306.763C403.962 306.763 404.246 306.843 404.494 307.002C404.746 307.158 404.928 307.38 405.04 307.669H404.447Z"
        fill="#0E4D0D"
      />
      <path
        d="M402.104 307.125C402.104 306.831 402.171 306.566 402.307 306.333C402.446 306.099 402.632 305.917 402.866 305.787C403.103 305.654 403.361 305.588 403.641 305.588C403.962 305.588 404.246 305.667 404.494 305.826C404.746 305.982 404.928 306.204 405.04 306.493H404.447C404.369 306.334 404.261 306.216 404.122 306.138C403.983 306.06 403.823 306.021 403.641 306.021C403.442 306.021 403.264 306.065 403.108 306.155C402.953 306.244 402.83 306.373 402.74 306.54C402.654 306.708 402.61 306.903 402.61 307.125C402.61 307.347 402.654 307.542 402.74 307.71C402.83 307.877 402.953 308.007 403.108 308.1C403.264 308.189 403.442 308.234 403.641 308.234C403.823 308.234 403.983 308.195 404.122 308.117C404.261 308.039 404.369 307.921 404.447 307.762H405.04C404.928 308.051 404.746 308.273 404.494 308.429C404.246 308.585 403.962 308.663 403.641 308.663C403.358 308.663 403.1 308.598 402.866 308.468C402.632 308.335 402.446 308.152 402.307 307.918C402.171 307.684 402.104 307.42 402.104 307.125ZM406.991 308.667C406.711 308.667 406.453 308.602 406.216 308.472C405.982 308.339 405.796 308.156 405.657 307.922C405.521 307.685 405.453 307.42 405.453 307.125C405.453 306.831 405.521 306.566 405.657 306.333C405.796 306.099 405.982 305.917 406.216 305.787C406.453 305.654 406.711 305.588 406.991 305.588C407.274 305.588 407.532 305.654 407.766 305.787C408.003 305.917 408.189 306.099 408.325 306.333C408.461 306.566 408.529 306.831 408.529 307.125C408.529 307.42 408.461 307.685 408.325 307.922C408.189 308.156 408.003 308.339 407.766 308.472C407.532 308.602 407.274 308.667 406.991 308.667ZM406.991 308.238C407.19 308.238 407.368 308.193 407.524 308.104C407.68 308.012 407.801 307.882 407.888 307.714C407.977 307.544 408.022 307.347 408.022 307.125C408.022 306.903 407.977 306.708 407.888 306.54C407.801 306.373 407.68 306.244 407.524 306.155C407.368 306.065 407.19 306.021 406.991 306.021C406.792 306.021 406.614 306.065 406.458 306.155C406.302 306.244 406.18 306.373 406.09 306.54C406.004 306.708 405.96 306.903 405.96 307.125C405.96 307.347 406.004 307.544 406.09 307.714C406.18 307.882 406.302 308.012 406.458 308.104C406.614 308.193 406.792 308.238 406.991 308.238ZM402.476 313.965C402.753 313.726 402.971 313.529 403.13 313.376C403.292 313.22 403.426 313.059 403.533 312.891C403.64 312.724 403.693 312.556 403.693 312.389C403.693 312.216 403.651 312.08 403.568 311.982C403.487 311.884 403.358 311.834 403.182 311.834C403.012 311.834 402.879 311.889 402.784 311.999C402.691 312.106 402.642 312.25 402.636 312.432H402.16C402.169 312.103 402.267 311.852 402.454 311.679C402.645 311.502 402.886 311.414 403.178 311.414C403.492 311.414 403.738 311.501 403.914 311.674C404.093 311.847 404.183 312.078 404.183 312.367C404.183 312.575 404.129 312.776 404.022 312.969C403.918 313.16 403.793 313.332 403.645 313.485C403.501 313.635 403.316 313.809 403.091 314.009L402.896 314.182H404.269V314.593H402.164V314.234L402.476 313.965Z"
        fill="#0E4D0D"
      />
      <path
        d="M327.617 284.156V283.706H328.518V286.863H328.02V284.156H327.617ZM329.196 285.243C329.196 284.744 329.28 284.354 329.447 284.074C329.618 283.791 329.909 283.65 330.322 283.65C330.735 283.65 331.025 283.791 331.193 284.074C331.363 284.354 331.448 284.744 331.448 285.243C331.448 285.749 331.363 286.144 331.193 286.43C331.025 286.713 330.735 286.855 330.322 286.855C329.909 286.855 329.618 286.713 329.447 286.43C329.28 286.144 329.196 285.749 329.196 285.243ZM330.963 285.243C330.963 285.01 330.947 284.812 330.915 284.65C330.887 284.488 330.826 284.357 330.733 284.256C330.641 284.152 330.504 284.1 330.322 284.1C330.14 284.1 330.003 284.152 329.911 284.256C329.818 284.357 329.756 284.488 329.724 284.65C329.695 284.812 329.681 285.01 329.681 285.243C329.681 285.486 329.695 285.69 329.724 285.854C329.753 286.019 329.814 286.152 329.906 286.253C330.002 286.354 330.14 286.404 330.322 286.404C330.504 286.404 330.641 286.354 330.733 286.253C330.829 286.152 330.891 286.019 330.92 285.854C330.949 285.69 330.963 285.486 330.963 285.243ZM332.235 286.894C332.145 286.894 332.07 286.863 332.01 286.803C331.949 286.742 331.919 286.667 331.919 286.577C331.919 286.488 331.949 286.413 332.01 286.352C332.07 286.292 332.145 286.261 332.235 286.261C332.321 286.261 332.395 286.292 332.456 286.352C332.516 286.413 332.547 286.488 332.547 286.577C332.547 286.667 332.516 286.742 332.456 286.803C332.395 286.863 332.321 286.894 332.235 286.894ZM327.621 292.205V291.832L329.076 289.745H329.674V291.776H330.077V292.205H329.674V292.863H329.189V292.205H327.621ZM329.211 290.247L328.188 291.776H329.211V290.247ZM332.21 292.863L331.045 291.516V292.863H330.551V289.853H331.045V291.226L332.214 289.853H332.833L331.525 291.36L332.855 292.863H332.21ZM335.47 290.719C335.392 290.569 335.284 290.457 335.145 290.382C335.007 290.304 334.847 290.265 334.665 290.265C334.465 290.265 334.288 290.309 334.132 290.399C333.976 290.488 333.853 290.615 333.764 290.78C333.677 290.945 333.634 291.135 333.634 291.352C333.634 291.568 333.677 291.76 333.764 291.928C333.853 292.092 333.976 292.219 334.132 292.309C334.288 292.398 334.465 292.443 334.665 292.443C334.933 292.443 335.151 292.368 335.319 292.218C335.486 292.068 335.589 291.864 335.626 291.607H334.496V291.213H336.155V291.599C336.123 291.832 336.039 292.048 335.903 292.244C335.771 292.44 335.596 292.598 335.379 292.716C335.166 292.832 334.927 292.889 334.665 292.889C334.382 292.889 334.123 292.824 333.889 292.694C333.656 292.562 333.469 292.378 333.331 292.144C333.195 291.91 333.127 291.646 333.127 291.352C333.127 291.057 333.195 290.793 333.331 290.559C333.469 290.325 333.656 290.143 333.889 290.013C334.126 289.881 334.385 289.814 334.665 289.814C334.985 289.814 335.27 289.894 335.518 290.052C335.769 290.208 335.951 290.431 336.064 290.719H335.47Z"
        fill="#0E4D0D"
      />
      <path
        d="M327.582 290.176C327.582 289.881 327.65 289.617 327.786 289.383C327.924 289.149 328.111 288.968 328.344 288.838C328.581 288.705 328.84 288.638 329.12 288.638C329.44 288.638 329.725 288.718 329.973 288.877C330.224 289.033 330.406 289.255 330.519 289.544H329.925C329.847 289.385 329.739 289.266 329.6 289.188C329.462 289.11 329.302 289.071 329.12 289.071C328.92 289.071 328.743 289.116 328.587 289.206C328.431 289.295 328.308 289.424 328.219 289.591C328.132 289.759 328.089 289.954 328.089 290.176C328.089 290.398 328.132 290.593 328.219 290.761C328.308 290.928 328.431 291.058 328.587 291.15C328.743 291.24 328.92 291.285 329.12 291.285C329.302 291.285 329.462 291.246 329.6 291.168C329.739 291.09 329.847 290.971 329.925 290.813H330.519C330.406 291.101 330.224 291.324 329.973 291.48C329.725 291.636 329.44 291.713 329.12 291.713C328.837 291.713 328.578 291.649 328.344 291.519C328.111 291.386 327.924 291.202 327.786 290.969C327.65 290.735 327.582 290.47 327.582 290.176ZM332.47 291.718C332.189 291.718 331.931 291.653 331.694 291.523C331.46 291.39 331.274 291.207 331.136 290.973C331 290.736 330.932 290.47 330.932 290.176C330.932 289.881 331 289.617 331.136 289.383C331.274 289.149 331.46 288.968 331.694 288.838C331.931 288.705 332.189 288.638 332.47 288.638C332.753 288.638 333.011 288.705 333.245 288.838C333.482 288.968 333.668 289.149 333.804 289.383C333.939 289.617 334.007 289.881 334.007 290.176C334.007 290.47 333.939 290.736 333.804 290.973C333.668 291.207 333.482 291.39 333.245 291.523C333.011 291.653 332.753 291.718 332.47 291.718ZM332.47 291.289C332.669 291.289 332.846 291.244 333.002 291.155C333.158 291.062 333.279 290.932 333.366 290.765C333.456 290.595 333.5 290.398 333.5 290.176C333.5 289.954 333.456 289.759 333.366 289.591C333.279 289.424 333.158 289.295 333.002 289.206C332.846 289.116 332.669 289.071 332.47 289.071C332.27 289.071 332.093 289.116 331.937 289.206C331.781 289.295 331.658 289.424 331.569 289.591C331.482 289.759 331.439 289.954 331.439 290.176C331.439 290.398 331.482 290.595 331.569 290.765C331.658 290.932 331.781 291.062 331.937 291.155C332.093 291.244 332.27 291.289 332.47 291.289ZM327.955 297.016C328.232 296.777 328.45 296.58 328.609 296.427C328.77 296.271 328.905 296.11 329.011 295.942C329.118 295.775 329.172 295.607 329.172 295.44C329.172 295.266 329.13 295.131 329.046 295.033C328.965 294.934 328.837 294.885 328.661 294.885C328.49 294.885 328.357 294.94 328.262 295.05C328.17 295.157 328.121 295.301 328.115 295.483H327.638C327.647 295.154 327.745 294.903 327.933 294.729C328.124 294.553 328.365 294.465 328.656 294.465C328.971 294.465 329.216 294.552 329.393 294.725C329.572 294.898 329.661 295.129 329.661 295.418C329.661 295.626 329.608 295.827 329.501 296.02C329.397 296.211 329.271 296.382 329.124 296.535C328.98 296.686 328.795 296.86 328.57 297.059L328.375 297.233H329.748V297.644H327.643V297.285L327.955 297.016Z"
        fill="#0E4D0D"
      />
      <path
        d="M365.727 286.006C365.756 286.15 365.818 286.26 365.914 286.335C366.009 286.41 366.137 286.447 366.299 286.447C366.504 286.447 366.654 286.367 366.75 286.205C366.845 286.043 366.893 285.768 366.893 285.378C366.823 285.476 366.725 285.552 366.598 285.607C366.474 285.659 366.338 285.685 366.191 285.685C366.003 285.685 365.833 285.648 365.68 285.573C365.527 285.495 365.405 285.381 365.316 285.23C365.229 285.077 365.186 284.893 365.186 284.676C365.186 284.358 365.278 284.106 365.463 283.918C365.651 283.728 365.908 283.632 366.234 283.632C366.627 283.632 366.905 283.764 367.07 284.026C367.238 284.286 367.321 284.686 367.321 285.226C367.321 285.599 367.29 285.903 367.226 286.14C367.165 286.377 367.059 286.556 366.905 286.677C366.752 286.798 366.54 286.859 366.269 286.859C365.96 286.859 365.722 286.778 365.554 286.616C365.387 286.455 365.293 286.251 365.273 286.006H365.727ZM366.277 285.269C366.451 285.269 366.586 285.216 366.685 285.109C366.786 284.999 366.836 284.855 366.836 284.676C366.836 284.477 366.783 284.322 366.676 284.213C366.572 284.1 366.429 284.044 366.247 284.044C366.065 284.044 365.921 284.101 365.814 284.217C365.71 284.33 365.658 284.478 365.658 284.663C365.658 284.839 365.709 284.985 365.81 285.101C365.914 285.213 366.07 285.269 366.277 285.269ZM368.126 286.894C368.036 286.894 367.961 286.863 367.901 286.803C367.84 286.742 367.81 286.667 367.81 286.577C367.81 286.488 367.84 286.413 367.901 286.352C367.961 286.292 368.036 286.261 368.126 286.261C368.212 286.261 368.286 286.292 368.347 286.352C368.407 286.413 368.438 286.488 368.438 286.577C368.438 286.667 368.407 286.742 368.347 286.803C368.286 286.863 368.212 286.894 368.126 286.894ZM369.439 285.213C369.139 285.063 368.989 284.826 368.989 284.503C368.989 284.347 369.028 284.204 369.106 284.074C369.184 283.944 369.301 283.842 369.456 283.767C369.612 283.689 369.803 283.65 370.028 283.65C370.25 283.65 370.44 283.689 370.596 283.767C370.754 283.842 370.873 283.944 370.951 284.074C371.029 284.204 371.068 284.347 371.068 284.503C371.068 284.665 371.026 284.807 370.942 284.932C370.861 285.053 370.753 285.147 370.617 285.213C370.782 285.274 370.912 285.373 371.007 285.512C371.102 285.648 371.15 285.808 371.15 285.993C371.15 286.18 371.102 286.346 371.007 286.491C370.912 286.635 370.779 286.746 370.609 286.824C370.438 286.902 370.245 286.941 370.028 286.941C369.812 286.941 369.618 286.902 369.448 286.824C369.28 286.746 369.149 286.635 369.054 286.491C368.958 286.346 368.911 286.18 368.911 285.993C368.911 285.805 368.958 285.643 369.054 285.508C369.149 285.372 369.277 285.274 369.439 285.213ZM370.596 284.563C370.596 284.402 370.545 284.278 370.444 284.191C370.343 284.104 370.204 284.061 370.028 284.061C369.855 284.061 369.718 284.104 369.617 284.191C369.516 284.278 369.465 284.403 369.465 284.568C369.465 284.712 369.517 284.831 369.621 284.923C369.728 285.012 369.864 285.057 370.028 285.057C370.193 285.057 370.328 285.011 370.435 284.919C370.542 284.826 370.596 284.708 370.596 284.563ZM370.028 285.43C369.838 285.43 369.682 285.477 369.56 285.573C369.442 285.665 369.383 285.799 369.383 285.975C369.383 286.14 369.441 286.274 369.556 286.378C369.672 286.479 369.829 286.53 370.028 286.53C370.224 286.53 370.379 286.478 370.492 286.374C370.607 286.27 370.665 286.137 370.665 285.975C370.665 285.802 370.606 285.668 370.487 285.573C370.372 285.477 370.219 285.43 370.028 285.43ZM373.392 286.863L372.227 285.516V286.863H371.733V283.853H372.227V285.226L373.396 283.853H374.016L372.708 285.36L374.037 286.863H373.392ZM367.356 290.719C367.278 290.569 367.17 290.457 367.031 290.382C366.893 290.304 366.732 290.265 366.55 290.265C366.351 290.265 366.174 290.309 366.018 290.399C365.862 290.488 365.739 290.615 365.649 290.78C365.563 290.945 365.52 291.135 365.52 291.352C365.52 291.568 365.563 291.76 365.649 291.928C365.739 292.092 365.862 292.219 366.018 292.309C366.174 292.398 366.351 292.443 366.55 292.443C366.819 292.443 367.037 292.368 367.204 292.218C367.372 292.068 367.474 291.864 367.512 291.607H366.381V291.213H368.04V291.599C368.008 291.832 367.925 292.048 367.789 292.244C367.656 292.44 367.482 292.598 367.265 292.716C367.051 292.832 366.813 292.889 366.55 292.889C366.267 292.889 366.009 292.824 365.775 292.694C365.541 292.562 365.355 292.378 365.216 292.144C365.081 291.91 365.013 291.646 365.013 291.352C365.013 291.057 365.081 290.793 365.216 290.559C365.355 290.325 365.541 290.143 365.775 290.013C366.012 289.881 366.27 289.814 366.55 289.814C366.871 289.814 367.155 289.894 367.404 290.052C367.655 290.208 367.837 290.431 367.949 290.719H367.356Z"
        fill="#0E4D0D"
      />
      <path
        d="M365.013 290.176C365.013 289.881 365.081 289.617 365.216 289.383C365.355 289.149 365.541 288.968 365.775 288.838C366.012 288.705 366.27 288.638 366.55 288.638C366.871 288.638 367.155 288.718 367.404 288.877C367.655 289.033 367.837 289.255 367.949 289.544H367.356C367.278 289.385 367.17 289.266 367.031 289.188C366.893 289.11 366.732 289.071 366.55 289.071C366.351 289.071 366.174 289.116 366.018 289.206C365.862 289.295 365.739 289.424 365.649 289.591C365.563 289.759 365.52 289.954 365.52 290.176C365.52 290.398 365.563 290.593 365.649 290.761C365.739 290.928 365.862 291.058 366.018 291.15C366.174 291.24 366.351 291.285 366.55 291.285C366.732 291.285 366.893 291.246 367.031 291.168C367.17 291.09 367.278 290.971 367.356 290.813H367.949C367.837 291.101 367.655 291.324 367.404 291.48C367.155 291.636 366.871 291.713 366.55 291.713C366.267 291.713 366.009 291.649 365.775 291.519C365.541 291.386 365.355 291.202 365.216 290.969C365.081 290.735 365.013 290.47 365.013 290.176ZM369.9 291.718C369.62 291.718 369.362 291.653 369.125 291.523C368.891 291.39 368.705 291.207 368.566 290.973C368.431 290.736 368.363 290.47 368.363 290.176C368.363 289.881 368.431 289.617 368.566 289.383C368.705 289.149 368.891 288.968 369.125 288.838C369.362 288.705 369.62 288.638 369.9 288.638C370.183 288.638 370.442 288.705 370.675 288.838C370.912 288.968 371.098 289.149 371.234 289.383C371.37 289.617 371.438 289.881 371.438 290.176C371.438 290.47 371.37 290.736 371.234 290.973C371.098 291.207 370.912 291.39 370.675 291.523C370.442 291.653 370.183 291.718 369.9 291.718ZM369.9 291.289C370.099 291.289 370.277 291.244 370.433 291.155C370.589 291.062 370.71 290.932 370.797 290.765C370.886 290.595 370.931 290.398 370.931 290.176C370.931 289.954 370.886 289.759 370.797 289.591C370.71 289.424 370.589 289.295 370.433 289.206C370.277 289.116 370.099 289.071 369.9 289.071C369.701 289.071 369.523 289.116 369.367 289.206C369.212 289.295 369.089 289.424 368.999 289.591C368.913 289.759 368.869 289.954 368.869 290.176C368.869 290.398 368.913 290.595 368.999 290.765C369.089 290.932 369.212 291.062 369.367 291.155C369.523 291.244 369.701 291.289 369.9 291.289ZM365.385 297.016C365.662 296.777 365.88 296.58 366.039 296.427C366.201 296.271 366.335 296.11 366.442 295.942C366.549 295.775 366.602 295.607 366.602 295.44C366.602 295.266 366.56 295.131 366.477 295.033C366.396 294.934 366.267 294.885 366.091 294.885C365.921 294.885 365.788 294.94 365.693 295.05C365.6 295.157 365.551 295.301 365.546 295.483H365.069C365.078 295.154 365.176 294.903 365.364 294.729C365.554 294.553 365.795 294.465 366.087 294.465C366.402 294.465 366.647 294.552 366.823 294.725C367.002 294.898 367.092 295.129 367.092 295.418C367.092 295.626 367.038 295.827 366.931 296.02C366.828 296.211 366.702 296.382 366.555 296.535C366.41 296.686 366.226 296.86 366 297.059L365.805 297.233H367.178V297.644H365.073V297.285L365.385 297.016Z"
        fill="#0E4D0D"
      />
      <path
        d="M402.195 284.485C402.212 284.217 402.314 284.008 402.502 283.857C402.693 283.707 402.935 283.632 403.23 283.632C403.432 283.632 403.607 283.668 403.754 283.741C403.901 283.813 404.012 283.911 404.087 284.035C404.162 284.159 404.2 284.299 404.2 284.455C404.2 284.634 404.152 284.787 404.057 284.914C403.962 285.041 403.848 285.126 403.715 285.17V285.187C403.885 285.239 404.018 285.334 404.113 285.473C404.209 285.609 404.256 285.783 404.256 285.997C404.256 286.167 404.217 286.319 404.139 286.452C404.061 286.585 403.946 286.69 403.793 286.768C403.64 286.843 403.456 286.881 403.243 286.881C402.931 286.881 402.674 286.801 402.472 286.642C402.273 286.481 402.166 286.25 402.151 285.949H402.628C402.639 286.102 402.698 286.228 402.805 286.326C402.912 286.422 403.056 286.469 403.238 286.469C403.414 286.469 403.55 286.422 403.645 286.326C403.741 286.228 403.788 286.102 403.788 285.949C403.788 285.747 403.723 285.604 403.594 285.521C403.466 285.434 403.27 285.391 403.004 285.391H402.892V284.984H403.009C403.243 284.981 403.42 284.942 403.542 284.867C403.666 284.792 403.728 284.673 403.728 284.511C403.728 284.373 403.683 284.263 403.594 284.182C403.504 284.099 403.377 284.057 403.212 284.057C403.051 284.057 402.925 284.099 402.836 284.182C402.746 284.263 402.693 284.364 402.675 284.485H402.195ZM405.039 286.894C404.95 286.894 404.874 286.863 404.814 286.803C404.753 286.742 404.723 286.667 404.723 286.577C404.723 286.488 404.753 286.413 404.814 286.352C404.874 286.292 404.95 286.261 405.039 286.261C405.126 286.261 405.199 286.292 405.26 286.352C405.321 286.413 405.351 286.488 405.351 286.577C405.351 286.667 405.321 286.742 405.26 286.803C405.199 286.863 405.126 286.894 405.039 286.894ZM406.435 286.006C406.463 286.15 406.526 286.26 406.621 286.335C406.716 286.41 406.845 286.447 407.006 286.447C407.211 286.447 407.361 286.367 407.457 286.205C407.552 286.043 407.6 285.768 407.6 285.378C407.53 285.476 407.432 285.552 407.305 285.607C407.181 285.659 407.045 285.685 406.898 285.685C406.71 285.685 406.54 285.648 406.387 285.573C406.234 285.495 406.113 285.381 406.023 285.23C405.936 285.077 405.893 284.893 405.893 284.676C405.893 284.358 405.986 284.106 406.17 283.918C406.358 283.728 406.615 283.632 406.941 283.632C407.334 283.632 407.613 283.764 407.777 284.026C407.945 284.286 408.028 284.686 408.028 285.226C408.028 285.599 407.997 285.903 407.933 286.14C407.873 286.377 407.766 286.556 407.613 286.677C407.46 286.798 407.247 286.859 406.976 286.859C406.667 286.859 406.429 286.778 406.261 286.616C406.094 286.455 406 286.251 405.98 286.006H406.435ZM406.985 285.269C407.158 285.269 407.294 285.216 407.392 285.109C407.493 284.999 407.543 284.855 407.543 284.676C407.543 284.477 407.49 284.322 407.383 284.213C407.279 284.1 407.136 284.044 406.954 284.044C406.772 284.044 406.628 284.101 406.521 284.217C406.417 284.33 406.365 284.478 406.365 284.663C406.365 284.839 406.416 284.985 406.517 285.101C406.621 285.213 406.777 285.269 406.985 285.269ZM410.293 286.863L409.128 285.516V286.863H408.634V283.853H409.128V285.226L410.297 283.853H410.916L409.608 285.36L410.938 286.863H410.293ZM404.447 290.719C404.369 290.569 404.261 290.457 404.122 290.382C403.983 290.304 403.823 290.265 403.641 290.265C403.442 290.265 403.264 290.309 403.108 290.399C402.953 290.488 402.83 290.615 402.74 290.78C402.654 290.945 402.61 291.135 402.61 291.352C402.61 291.568 402.654 291.76 402.74 291.928C402.83 292.092 402.953 292.219 403.108 292.309C403.264 292.398 403.442 292.443 403.641 292.443C403.91 292.443 404.128 292.368 404.295 292.218C404.463 292.068 404.565 291.864 404.603 291.607H403.472V291.213H405.131V291.599C405.099 291.832 405.016 292.048 404.88 292.244C404.747 292.44 404.572 292.598 404.356 292.716C404.142 292.832 403.904 292.889 403.641 292.889C403.358 292.889 403.1 292.824 402.866 292.694C402.632 292.562 402.446 292.378 402.307 292.144C402.171 291.91 402.104 291.646 402.104 291.352C402.104 291.057 402.171 290.793 402.307 290.559C402.446 290.325 402.632 290.143 402.866 290.013C403.103 289.881 403.361 289.814 403.641 289.814C403.962 289.814 404.246 289.894 404.494 290.052C404.746 290.208 404.928 290.431 405.04 290.719H404.447Z"
        fill="#0E4D0D"
      />
      <path
        d="M402.104 290.176C402.104 289.881 402.171 289.617 402.307 289.383C402.446 289.149 402.632 288.968 402.866 288.838C403.103 288.705 403.361 288.638 403.641 288.638C403.962 288.638 404.246 288.718 404.494 288.877C404.746 289.033 404.928 289.255 405.04 289.544H404.447C404.369 289.385 404.261 289.266 404.122 289.188C403.983 289.11 403.823 289.071 403.641 289.071C403.442 289.071 403.264 289.116 403.108 289.206C402.953 289.295 402.83 289.424 402.74 289.591C402.654 289.759 402.61 289.954 402.61 290.176C402.61 290.398 402.654 290.593 402.74 290.761C402.83 290.928 402.953 291.058 403.108 291.15C403.264 291.24 403.442 291.285 403.641 291.285C403.823 291.285 403.983 291.246 404.122 291.168C404.261 291.09 404.369 290.971 404.447 290.813H405.04C404.928 291.101 404.746 291.324 404.494 291.48C404.246 291.636 403.962 291.713 403.641 291.713C403.358 291.713 403.1 291.649 402.866 291.519C402.632 291.386 402.446 291.202 402.307 290.969C402.171 290.735 402.104 290.47 402.104 290.176ZM406.991 291.718C406.711 291.718 406.453 291.653 406.216 291.523C405.982 291.39 405.796 291.207 405.657 290.973C405.521 290.736 405.453 290.47 405.453 290.176C405.453 289.881 405.521 289.617 405.657 289.383C405.796 289.149 405.982 288.968 406.216 288.838C406.453 288.705 406.711 288.638 406.991 288.638C407.274 288.638 407.532 288.705 407.766 288.838C408.003 288.968 408.189 289.149 408.325 289.383C408.461 289.617 408.529 289.881 408.529 290.176C408.529 290.47 408.461 290.736 408.325 290.973C408.189 291.207 408.003 291.39 407.766 291.523C407.532 291.653 407.274 291.718 406.991 291.718ZM406.991 291.289C407.19 291.289 407.368 291.244 407.524 291.155C407.68 291.062 407.801 290.932 407.888 290.765C407.977 290.595 408.022 290.398 408.022 290.176C408.022 289.954 407.977 289.759 407.888 289.591C407.801 289.424 407.68 289.295 407.524 289.206C407.368 289.116 407.19 289.071 406.991 289.071C406.792 289.071 406.614 289.116 406.458 289.206C406.302 289.295 406.18 289.424 406.09 289.591C406.004 289.759 405.96 289.954 405.96 290.176C405.96 290.398 406.004 290.595 406.09 290.765C406.18 290.932 406.302 291.062 406.458 291.155C406.614 291.244 406.792 291.289 406.991 291.289ZM402.476 297.016C402.753 296.777 402.971 296.58 403.13 296.427C403.292 296.271 403.426 296.11 403.533 295.942C403.64 295.775 403.693 295.607 403.693 295.44C403.693 295.266 403.651 295.131 403.568 295.033C403.487 294.934 403.358 294.885 403.182 294.885C403.012 294.885 402.879 294.94 402.784 295.05C402.691 295.157 402.642 295.301 402.636 295.483H402.16C402.169 295.154 402.267 294.903 402.454 294.729C402.645 294.553 402.886 294.465 403.178 294.465C403.492 294.465 403.738 294.552 403.914 294.725C404.093 294.898 404.183 295.129 404.183 295.418C404.183 295.626 404.129 295.827 404.022 296.02C403.918 296.211 403.793 296.382 403.645 296.535C403.501 296.686 403.316 296.86 403.091 297.059L402.896 297.233H404.269V297.644H402.164V297.285L402.476 297.016Z"
        fill="#0E4D0D"
      />
      <path
        d="M371.511 245.238L371.512 241.578L342.712 241.573L342.711 245.233L371.511 245.238Z"
        fill="#0E4D0D"
      />
      <path
        d="M366.973 251.199V247.539H342.764V251.199H366.973Z"
        fill="#0E4D0D"
      />
      <path
        d="M342.929 255.238H372.663"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M342.929 258.531H363.381"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M342.929 261.84H369.053"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M342.929 265.137H365.481"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M383.879 263.848H387.048V258.254H383.879V263.848Z"
        fill="#0E4D0D"
      />
      <path
        d="M388.798 263.848H391.967V249.1H388.798V263.848Z"
        fill="#0E4D0D"
      />
      <path
        d="M393.712 263.848H396.881V254.18H393.712V263.848Z"
        fill="#0E4D0D"
      />
      <path
        d="M382.447 263.848H398.322"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M342.929 268.43H353.114"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M420.883 225.102H405.225V226.693H420.883V225.102Z"
        fill="#0E4D0D"
      />
      <path
        d="M400.498 225.102H379.821V226.693H400.498V225.102Z"
        fill="#0E4D0D"
      />
      <path
        d="M377.473 221.809H368.497V229.172H377.473V221.809Z"
        fill="#0E4D0D"
      />
      <path
        d="M375.161 225.102H370.832V226.693H375.161V225.102Z"
        fill="white"
      />
      <path
        d="M427.723 228.025C429.046 228.025 430.118 226.952 430.118 225.629C430.118 224.307 429.046 223.234 427.723 223.234C426.4 223.234 425.328 224.307 425.328 225.629C425.328 226.952 426.4 228.025 427.723 228.025Z"
        fill="#0E4D0D"
      />
      <path
        d="M318.282 223.938C318.688 223.938 319.094 223.938 319.5 223.938C319.524 223.938 319.53 223.94 319.53 223.967C319.53 224.101 319.53 224.235 319.53 224.37C319.53 224.396 319.521 224.399 319.497 224.399C319.194 224.399 318.89 224.399 318.586 224.399C318.563 224.399 318.557 224.405 318.557 224.428C318.557 225.229 318.557 226.029 318.557 226.829C318.557 226.87 318.563 226.864 318.519 226.864C318.361 226.864 318.201 226.864 318.043 226.864C318.017 226.864 318.011 226.855 318.011 226.832C318.011 226.032 318.011 225.231 318.011 224.431C318.011 224.405 318.005 224.396 317.976 224.396C317.672 224.396 317.368 224.396 317.067 224.396C317.044 224.396 317.038 224.39 317.038 224.367C317.038 224.232 317.038 224.098 317.038 223.964C317.038 223.943 317.044 223.938 317.064 223.938C317.47 223.938 317.876 223.938 318.282 223.938Z"
        fill="#0E4D0D"
      />
      <path
        d="M314.153 224.433C314.066 224.536 313.981 224.644 313.899 224.75C313.89 224.761 313.884 224.764 313.873 224.75C313.788 224.65 313.706 224.551 313.621 224.451C313.603 224.431 313.621 224.431 313.63 224.425C313.735 224.378 313.843 224.363 313.957 224.375C314.025 224.381 314.089 224.398 314.153 224.431V224.433Z"
        fill="#FFA366"
      />
      <path
        d="M316.836 224.784C316.588 224.258 316.176 223.958 315.592 223.908C315.367 223.887 315.151 223.923 314.941 224.004C314.643 224.115 314.4 224.302 314.199 224.548C314.099 224.667 314.003 224.79 313.907 224.913C313.895 224.93 313.886 224.933 313.872 224.913C313.802 224.828 313.731 224.746 313.661 224.662C313.53 224.507 313.401 224.352 313.241 224.226C312.823 223.902 312.359 223.82 311.856 223.972C311.52 224.071 311.257 224.276 311.062 224.562C310.892 224.808 310.805 225.079 310.802 225.377C310.802 225.52 310.819 225.663 310.86 225.801C310.959 226.148 311.152 226.432 311.453 226.636C311.739 226.832 312.061 226.916 312.405 226.899C312.575 226.89 312.738 226.852 312.893 226.785C312.911 226.779 312.914 226.773 312.902 226.756C312.826 226.639 312.753 226.522 312.677 226.405C312.665 226.385 312.651 226.376 312.627 226.385C312.402 226.458 312.177 226.449 311.955 226.373C311.406 226.183 311.12 225.552 311.339 225.015C311.523 224.565 311.976 224.305 312.455 224.372C312.703 224.407 312.914 224.521 313.08 224.708C313.244 224.895 313.404 225.082 313.568 225.272C313.58 225.284 313.58 225.289 313.568 225.304C313.518 225.363 313.469 225.421 313.419 225.479C313.331 225.579 313.235 225.672 313.162 225.783C313.086 225.891 313.033 226.011 313.025 226.142C313.01 226.385 313.098 226.583 313.285 226.741C313.41 226.846 313.556 226.902 313.723 226.902C313.831 226.902 313.939 226.902 314.047 226.902C314.161 226.902 314.266 226.876 314.365 226.823C314.809 226.589 314.85 226.055 314.573 225.728C314.453 225.587 314.33 225.447 314.21 225.31C314.196 225.295 314.196 225.287 314.21 225.269C314.313 225.152 314.412 225.035 314.514 224.916C314.608 224.808 314.701 224.699 314.812 224.609C315.13 224.352 315.484 224.291 315.864 224.445C316.223 224.594 316.439 224.872 316.5 225.254C316.55 225.573 316.459 225.859 316.243 226.099C316.053 226.309 315.814 226.423 315.528 226.44C315.411 226.446 315.294 226.434 315.183 226.399C315.163 226.394 315.154 226.399 315.145 226.414C315.125 226.452 315.098 226.484 315.078 226.522C315.02 226.613 314.961 226.703 314.903 226.794C315.002 226.835 315.101 226.864 315.204 226.881C315.469 226.928 315.729 226.905 315.978 226.811C316.547 226.592 316.883 226.186 316.962 225.579C316.997 225.307 316.962 225.038 316.842 224.79L316.836 224.784ZM314.222 226.034C314.307 226.134 314.304 226.265 314.222 226.359C314.178 226.408 314.123 226.429 314.061 226.434C314.003 226.44 313.945 226.437 313.877 226.44C313.813 226.437 313.743 226.446 313.676 226.429C313.515 226.391 313.442 226.195 313.536 226.061C313.597 225.973 313.673 225.897 313.74 225.818C313.784 225.766 313.831 225.713 313.875 225.66C313.886 225.649 313.889 225.649 313.901 225.66C314.009 225.786 314.117 225.909 314.222 226.034Z"
        fill="#0E4D0D"
      />
      <path
        d="M310.665 226.843C310.458 226.546 310.248 226.248 310.04 225.953C310.005 225.903 310.005 225.906 310.061 225.88C310.245 225.798 310.4 225.675 310.499 225.497C310.642 225.243 310.662 224.974 310.595 224.697C310.534 224.434 310.373 224.241 310.14 224.11C309.929 223.993 309.701 223.943 309.465 223.94C309.038 223.934 308.615 223.94 308.188 223.94C308.185 223.94 308.18 223.94 308.177 223.94C308.177 224.904 308.177 225.868 308.177 226.832C308.177 226.855 308.183 226.864 308.209 226.861C308.378 226.861 308.548 226.861 308.717 226.861C308.717 226.852 308.717 226.841 308.717 226.832C308.717 226.569 308.717 226.303 308.717 226.04C308.717 226.02 308.723 226.011 308.743 226.011C308.854 226.011 308.968 226.011 309.079 226.011C309.211 226.011 309.342 226.017 309.477 226.008C309.494 226.008 309.5 226.017 309.509 226.029C309.699 226.3 309.888 226.572 310.078 226.846C310.087 226.861 310.099 226.867 310.116 226.867C310.294 226.867 310.473 226.867 310.651 226.867C310.659 226.867 310.668 226.87 310.674 226.861C310.671 226.855 310.668 226.849 310.665 226.846V226.843ZM309.684 225.52C309.579 225.552 309.474 225.561 309.366 225.561C309.161 225.561 308.954 225.561 308.749 225.561C308.726 225.561 308.72 225.555 308.72 225.532C308.72 225.348 308.72 225.164 308.72 224.98C308.72 224.796 308.72 224.609 308.72 224.425C308.72 224.402 308.726 224.396 308.749 224.396C308.965 224.396 309.179 224.396 309.395 224.396C309.529 224.396 309.663 224.416 309.786 224.478C309.947 224.553 310.043 224.682 310.069 224.857C310.09 224.974 310.084 225.091 310.043 225.202C309.979 225.371 309.85 225.468 309.684 225.52Z"
        fill="#0E4D0D"
      />
      <path
        d="M313.876 226.331C313.826 226.328 313.765 226.337 313.703 226.322C313.616 226.302 313.575 226.208 313.616 226.129C313.639 226.085 313.677 226.05 313.709 226.012C313.724 225.991 313.744 225.974 313.759 225.953C313.771 225.939 313.779 225.939 313.797 225.947C313.859 225.983 313.92 225.983 313.981 225.947C313.999 225.939 314.008 225.939 314.019 225.953C314.06 226 314.101 226.047 314.139 226.094C314.186 226.149 314.189 226.223 314.148 226.278C314.119 226.316 314.078 226.322 314.034 226.328C313.984 226.334 313.932 226.331 313.873 226.331H313.876Z"
        fill="#FFA366"
      />
      <path
        d="M411.659 263.729C416.604 263.729 420.612 259.721 420.612 254.777C420.612 249.832 416.604 245.824 411.659 245.824C406.715 245.824 402.707 249.832 402.707 254.777C402.707 259.721 406.715 263.729 411.659 263.729Z"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M419.949 251.395L411.659 254.777"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M411.659 245.824V254.774L414.636 263.221"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M252.582 217.52H202.842C200.245 217.52 198.14 219.625 198.14 222.222V287.434C198.14 290.031 200.245 292.136 202.842 292.136H252.582C255.179 292.136 257.284 290.031 257.284 287.434V222.222C257.284 219.625 255.179 217.52 252.582 217.52Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M248.96 217.52H198.712C196.115 217.52 194.01 219.625 194.01 222.222V287.434C194.01 290.031 196.115 292.136 198.712 292.136H248.96C251.557 292.136 253.663 290.031 253.663 287.434V222.222C253.663 219.625 251.557 217.52 248.96 217.52Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M231.183 259.387H203.382C201.48 259.387 199.938 260.929 199.938 262.83C199.938 264.732 201.48 266.274 203.382 266.274H231.183C233.085 266.274 234.627 264.732 234.627 262.83C234.627 260.929 233.085 259.387 231.183 259.387Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M220.928 266.274H203.382C201.481 266.274 199.938 264.732 199.938 262.83C199.938 260.929 201.481 259.387 203.382 259.387H220.928V266.274Z"
        fill="#FFDD74"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M231.183 268.953H203.382C201.48 268.953 199.938 270.495 199.938 272.397C199.938 274.299 201.48 275.841 203.382 275.841H231.183C233.085 275.841 234.627 274.299 234.627 272.397C234.627 270.495 233.085 268.953 231.183 268.953Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M224.845 275.841H203.382C201.481 275.841 199.938 274.298 199.938 272.397C199.938 270.495 201.481 268.953 203.382 268.953H224.845V275.841Z"
        fill="#FFA366"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M231.183 278.492H203.382C201.48 278.492 199.938 280.034 199.938 281.936C199.938 283.838 201.48 285.38 203.382 285.38H231.183C233.085 285.38 234.627 283.838 234.627 281.936C234.627 280.034 233.085 278.492 231.183 278.492Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M216.398 285.38H203.382C201.481 285.38 199.938 283.837 199.938 281.936C199.938 280.034 201.481 278.492 203.382 278.492H216.398V285.38Z"
        fill="#6ACA68"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M227.334 224.781H203.371C201.965 224.781 200.824 225.922 200.824 227.328V251.291C200.824 252.698 201.965 253.838 203.371 253.838H227.334C228.741 253.838 229.881 252.698 229.881 251.291V227.328C229.881 225.922 228.741 224.781 227.334 224.781Z"
        fill="#177617"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M215.214 250.367L208.161 247.801C207.556 247.58 207.257 246.9 207.502 246.305L209.714 240.955C210.414 239.266 211.04 237.546 211.59 235.803L212.814 231.924C213.29 230.415 214.928 229.606 216.417 230.15L220.234 231.54C221.723 232.081 222.457 233.753 221.852 235.215L220.299 238.974C219.598 240.663 218.973 242.383 218.422 244.127L216.679 249.646C216.485 250.262 215.819 250.588 215.214 250.37V250.367Z"
        fill="#209E20"
        stroke="#B0E4AB"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M218.366 227.245L220.602 228.059C220.976 228.195 221.166 228.608 221.031 228.978L220.118 231.486L216.535 230.181L217.447 227.674C217.583 227.3 217.996 227.11 218.366 227.245Z"
        fill="#209E20"
        stroke="#B0E4AB"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M219.279 231.191L220.19 228.683C220.326 228.309 220.132 227.898 219.762 227.762"
        fill="#209E20"
      />
      <path
        d="M219.279 231.191L220.19 228.683C220.326 228.309 220.132 227.898 219.762 227.762"
        stroke="#B0E4AB"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M215.214 250.367L208.161 247.801C207.556 247.58 207.257 246.9 207.502 246.305L209.714 240.955C210.414 239.266 211.04 237.546 211.59 235.803L212.814 231.924C213.29 230.415 214.928 229.606 216.417 230.15L220.234 231.54C221.723 232.081 222.457 233.753 221.852 235.215L220.299 238.974C219.598 240.663 218.973 242.383 218.422 244.127L216.679 249.646C216.485 250.262 215.819 250.588 215.214 250.37V250.367Z"
        fill="#209E20"
        stroke="#B0E4AB"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M219.278 231.184C220.767 231.724 221.501 233.396 220.896 234.858L219.343 238.617C218.642 240.306 218.017 242.026 217.466 243.77L215.723 249.29C215.529 249.905 214.863 250.231 214.258 250.014"
        fill="#209E20"
      />
      <path
        d="M219.278 231.184C220.767 231.724 221.501 233.396 220.896 234.858L219.343 238.617C218.642 240.306 218.017 242.026 217.466 243.77L215.723 249.29C215.529 249.905 214.863 250.231 214.258 250.014"
        stroke="#B0E4AB"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M105.779 334.844C107.155 334.844 108.531 334.844 109.906 334.844C109.982 334.844 110.006 334.858 110.006 334.94C110 335.396 110 335.854 110.006 336.31C110.006 336.398 109.977 336.409 109.901 336.409C108.87 336.409 107.838 336.409 106.807 336.406C106.726 336.406 106.705 336.424 106.705 336.509C106.705 339.222 106.705 341.939 106.705 344.652C106.705 344.795 106.72 344.775 106.58 344.775C106.042 344.775 105.502 344.775 104.964 344.775C104.877 344.775 104.856 344.748 104.856 344.667C104.856 341.953 104.856 339.237 104.859 336.523C104.859 336.433 104.842 336.404 104.745 336.404C103.717 336.409 102.689 336.404 101.664 336.409C101.582 336.409 101.562 336.392 101.562 336.307C101.567 335.851 101.564 335.393 101.562 334.937C101.562 334.864 101.579 334.844 101.655 334.844C103.031 334.844 104.406 334.844 105.782 334.844H105.779Z"
        fill="#0E4D0D"
      />
      <path
        d="M91.7769 336.517C91.476 336.867 91.1986 337.226 90.9152 337.586C90.886 337.624 90.8685 337.632 90.8305 337.589C90.5472 337.253 90.261 336.917 89.9747 336.584C89.9192 336.52 89.9747 336.514 90.0098 336.496C90.3632 336.341 90.7341 336.289 91.1197 336.33C91.3475 336.353 91.5666 336.409 91.7798 336.517H91.7769Z"
        fill="#FFA366"
      />
      <path
        d="M100.878 337.712C100.04 335.927 98.6348 334.914 96.6574 334.741C95.9009 334.674 95.159 334.794 94.4463 335.063C93.4357 335.442 92.612 336.076 91.9314 336.903C91.5955 337.312 91.2684 337.726 90.9383 338.138C90.8945 338.194 90.8711 338.208 90.8186 338.144C90.5849 337.858 90.3454 337.577 90.1059 337.297C89.6619 336.774 89.2208 336.248 88.6746 335.825C87.2609 334.73 85.6837 334.452 83.9808 334.96C82.8475 335.299 81.9537 335.991 81.2848 336.964C80.7153 337.796 80.4173 338.717 80.4056 339.727C80.3998 340.215 80.4641 340.694 80.5984 341.161C80.9372 342.338 81.5886 343.297 82.608 343.992C83.5806 344.652 84.6643 344.938 85.8355 344.88C86.408 344.85 86.9601 344.722 87.4917 344.497C87.5501 344.474 87.5589 344.456 87.5238 344.401C87.2697 344.006 87.0156 343.612 86.7644 343.218C86.7206 343.148 86.6709 343.124 86.595 343.148C85.8326 343.396 85.0732 343.367 84.3196 343.104C82.459 342.458 81.4893 340.323 82.2312 338.5C82.8504 336.979 84.3926 336.091 86.0166 336.324C86.8608 336.444 87.5735 336.824 88.1372 337.461C88.6951 338.092 89.2384 338.734 89.7904 339.368C89.8255 339.409 89.8313 339.432 89.7904 339.476C89.6181 339.672 89.4516 339.87 89.2822 340.066C88.9901 340.408 88.663 340.72 88.4088 341.094C88.1547 341.465 87.9736 341.862 87.9473 342.315C87.9006 343.136 88.1985 343.816 88.8265 344.342C89.253 344.699 89.7466 344.888 90.3103 344.885C90.6784 344.885 91.0435 344.877 91.4115 344.885C91.7971 344.894 92.1563 344.795 92.4922 344.617C94.0023 343.819 94.1396 342.017 93.1962 340.898C92.7931 340.419 92.3783 339.952 91.9665 339.482C91.9197 339.429 91.9197 339.397 91.9665 339.345C92.3111 338.947 92.6529 338.55 92.9946 338.15C93.3101 337.779 93.6284 337.414 94.0052 337.107C95.083 336.234 96.2835 336.024 97.5658 336.555C98.7838 337.06 99.5199 337.998 99.7272 339.298C99.8996 340.379 99.587 341.342 98.8568 342.157C98.2113 342.873 97.3964 343.256 96.4325 343.314C96.0352 343.337 95.6439 343.294 95.2641 343.177C95.1999 343.156 95.1648 343.168 95.1298 343.229C95.0568 343.352 94.975 343.472 94.899 343.592C94.7033 343.895 94.5076 344.202 94.3061 344.515C94.642 344.652 94.9779 344.748 95.3226 344.81C96.2193 344.964 97.1014 344.891 97.9484 344.567C99.8791 343.828 101.021 342.447 101.284 340.384C101.401 339.458 101.278 338.556 100.881 337.709L100.878 337.712ZM92.0132 341.947C92.2994 342.286 92.2936 342.727 92.0074 343.051C91.8642 343.215 91.6715 343.285 91.4612 343.308C91.2625 343.332 91.061 343.323 90.8361 343.326C90.6229 343.311 90.3833 343.346 90.1497 343.288C89.6093 343.156 89.3523 342.493 89.6736 342.038C89.881 341.743 90.1351 341.486 90.3687 341.214C90.5206 341.036 90.6784 340.86 90.8302 340.682C90.8653 340.639 90.8857 340.639 90.9208 340.682C91.283 341.103 91.6539 341.521 92.0132 341.947Z"
        fill="#0E4D0D"
      />
      <path
        d="M79.9472 344.705C79.2404 343.697 78.5335 342.689 77.8237 341.682C77.7098 341.518 77.7098 341.518 77.8909 341.439C78.5189 341.159 79.0359 340.747 79.3806 340.145C79.8684 339.29 79.9326 338.369 79.7106 337.432C79.5003 336.541 78.9629 335.884 78.1655 335.44C77.4557 335.043 76.6817 334.873 75.8755 334.861C74.4355 334.844 72.9926 334.856 71.5526 334.853C71.5409 334.853 71.5293 334.853 71.5146 334.856C71.5146 338.124 71.5146 341.393 71.5146 344.661C71.5146 344.746 71.538 344.766 71.6198 344.763C72.1923 344.76 72.7677 344.763 73.3402 344.763C73.3402 344.728 73.349 344.696 73.349 344.661C73.349 343.767 73.349 342.871 73.349 341.977C73.349 341.907 73.3636 341.88 73.4395 341.883C73.8192 341.886 74.1989 341.886 74.5757 341.883C75.0226 341.88 75.4724 341.898 75.9193 341.869C75.9836 341.866 76.0011 341.904 76.0274 341.939C76.6729 342.862 77.3184 343.782 77.961 344.708C77.9961 344.757 78.0282 344.778 78.0895 344.778C78.6942 344.778 79.2988 344.778 79.9034 344.778C79.9297 344.778 79.9589 344.792 79.9852 344.76C79.9735 344.743 79.9647 344.722 79.9501 344.705H79.9472ZM76.6145 340.218C76.2611 340.326 75.8989 340.361 75.5309 340.361C74.8357 340.361 74.1376 340.361 73.4424 340.361C73.3606 340.361 73.346 340.338 73.346 340.262C73.346 339.637 73.346 339.012 73.346 338.387C73.346 337.762 73.346 337.131 73.346 336.5C73.346 336.421 73.3665 336.404 73.4454 336.404C74.1756 336.407 74.9058 336.404 75.636 336.41C76.0975 336.412 76.5473 336.483 76.9679 336.684C77.5112 336.947 77.8354 337.373 77.9318 337.969C77.9961 338.367 77.9815 338.761 77.8383 339.143C77.6251 339.716 77.187 340.043 76.6203 340.218H76.6145Z"
        fill="#0E4D0D"
      />
      <path
        d="M90.8304 342.962C90.6581 342.951 90.4507 342.98 90.2492 342.933C89.9571 342.866 89.811 342.545 89.9512 342.279C90.0301 342.127 90.1615 342.016 90.2667 341.885C90.3222 341.817 90.3835 341.753 90.4361 341.686C90.4741 341.636 90.5062 341.633 90.5617 341.666C90.7691 341.782 90.9794 341.782 91.1868 341.666C91.2452 341.633 91.2773 341.639 91.3211 341.689C91.4555 341.85 91.5957 342.004 91.733 342.162C91.8965 342.352 91.9053 342.594 91.7651 342.781C91.6687 342.91 91.5285 342.933 91.3825 342.951C91.2101 342.968 91.0378 342.962 90.8363 342.962H90.8304Z"
        fill="#FFA366"
      />
      <path
        d="M794.026 354.379V354.373C797.558 354.326 800.706 352.729 802.208 349.834C804.579 345.263 801.951 339.199 796.34 336.293C795.586 335.902 794.818 335.595 794.047 335.355C793.369 329.099 789.452 323.906 783.789 322.632C780.619 321.919 777.421 322.553 774.64 324.189C770.615 315.374 761.873 310.142 753.344 312.12C746.03 313.817 740.916 320.345 739.78 328.278C738.705 328.541 737.618 328.874 736.538 329.289C727.077 332.919 721.413 341.092 723.89 347.544C725.526 351.806 730.301 354.251 736.079 354.373V354.379H794.026Z"
        fill="#209E20"
      />
      <path
        d="M759.132 354.384C759.132 354.384 756.089 345.458 741.438 342.738"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M764.904 354.385C764.904 354.385 754.415 339.184 756.089 328.441"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M771.015 354.457C771.015 354.457 773.121 342.037 781.65 334.309"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M792.867 344.379C792.867 344.379 787.121 347.498 774.237 344.712"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M670.837 58.671C678.429 58.671 684.583 52.5168 684.583 44.9253C684.583 37.3338 678.429 31.1797 670.837 31.1797C663.246 31.1797 657.092 37.3338 657.092 44.9253C657.092 52.5168 663.246 58.671 670.837 58.671Z"
        fill="#FFDD74"
      />
      <path
        d="M726.04 59.647C725.339 59.2848 724.623 58.9985 723.904 58.7736C723.274 52.9494 719.625 48.1124 714.356 46.9295C711.406 46.2664 708.43 46.8564 705.839 48.3782C702.091 40.1706 693.954 35.3015 686.015 37.1416C679.206 38.7218 674.442 44.7972 673.385 52.1841C672.383 52.4295 671.375 52.7391 670.368 53.1246C661.561 56.5041 656.289 64.113 658.594 70.1212C660.115 74.0878 664.561 76.3631 669.941 76.48V76.4858H690.218C691.199 76.5822 692.195 76.5851 693.191 76.4858H708.894C709.77 76.5881 710.644 76.5881 711.502 76.4858H723.89V76.48C727.179 76.4362 730.108 74.9494 731.505 72.2535C733.713 67.9978 731.265 62.3546 726.042 59.647H726.04Z"
        fill="white"
      />
      <path
        d="M129.669 21.0902C130.314 20.7543 130.974 20.4914 131.637 20.2869C132.218 14.9213 135.58 10.464 140.435 9.37453C143.151 8.76407 145.897 9.30735 148.28 10.7094C151.733 3.14722 159.231 -1.33925 166.548 0.357783C172.822 1.81238 177.209 7.4117 178.184 14.2173C179.107 14.4423 180.036 14.7285 180.965 15.0848C189.079 18.1985 193.937 25.2086 191.813 30.7437C190.411 34.3977 186.313 36.4949 181.356 36.6029V36.6088H162.674C161.769 36.6964 160.855 36.6993 159.935 36.6088H145.468C144.661 36.7052 143.858 36.7023 143.064 36.6088H131.652V36.6029C128.623 36.562 125.924 35.1922 124.636 32.7094C122.603 28.7896 124.855 23.5875 129.669 21.0931V21.0902Z"
        fill="white"
      />
      <path
        d="M710.146 170.029C710.146 164.076 714.971 159.251 720.924 159.251C714.971 159.251 710.146 154.425 710.146 148.473C710.146 154.425 705.321 159.251 699.368 159.251C705.321 159.251 710.146 164.076 710.146 170.029Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M722.208 155.079C722.208 150.718 725.742 147.184 730.103 147.184C725.742 147.184 722.208 143.65 722.208 139.289C722.208 143.65 718.673 147.184 714.312 147.184C718.673 147.184 722.208 150.718 722.208 155.079Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M662.665 321.039H615.107V354.431H662.665V321.039Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M680.319 321.039H632.762V354.431H680.319V321.039Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M662.665 321.039H615.107V354.431H662.665V321.039Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M662.665 321.043L652.267 310.645H604.709L615.107 321.043H662.665Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M662.666 321.043L673.061 310.645H690.718L680.32 321.043H662.666Z"
        fill="#0E4D0D"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M629.309 329.654C624.381 344.46 633.9 347.486 636.173 347.992C636.465 348.056 636.766 347.948 636.95 347.708C638.369 345.859 643.714 337.424 630.421 329.248C630.007 328.994 629.46 329.193 629.306 329.654H629.309Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M648.513 327.556C651.344 346.498 639.032 347.92 636.406 348.011C636.105 348.023 635.825 347.859 635.682 347.593C634.446 345.277 629.522 333.903 647.342 326.881C647.859 326.677 648.429 327.007 648.51 327.556H648.513Z"
        fill="white"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M636.174 347.987C636.174 347.987 641.645 341.801 643.616 335.953L636.174 347.987Z"
        fill="white"
      />
      <path
        d="M636.174 347.987C636.174 347.987 641.645 341.801 643.616 335.953"
        stroke="#0E4D0D"
        strokeWidth="0.6"
        strokeMiterlimit="10"
      />
      <path
        d="M0.404297 354.462L827.597 354.461"
        stroke="#0E4D0D"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export default OnBoardingBannerImage;
